/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/src/app/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Page4_addmodem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__left_menu_component_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_window_component_js__ = __webpack_require__(27);




var Page4_addmodem = {
    name: 'Page4_addmodem',
    components: {
        'left-menu': __WEBPACK_IMPORTED_MODULE_1__left_menu_component_js__["a" /* Left_menu */],
        'form-window': __WEBPACK_IMPORTED_MODULE_2__form_window_component_js__["a" /* Form_window */]
    },
    template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */],
    data: function data() {
        return {
            tubes: [],
            phones: [],
            selected_phones: []
        };
    },

    created: function created() {
        var cont = this;
        // Первый запуск 
        this.getTubes();
        this.getPhones();
    },


    methods: {
        getTubes: function getTubes() {
            var cont = this;
            //запускаем аякс из плагина
            this.$API('static_data', 'tubes', {}, function (data) {
                cont.tubes = data;
            }, function (errorText) {
                console.log(errorText);
            });
        },
        getPhones: function getPhones() {
            var cont = this;
            this.$API('static_data', 'phones', {}, function (data) {
                for (var key in data) {
                    cont.phones.push({
                        text: data[key].name + ' \t \t \t ' + data[key].phone + '\t',
                        value: data[key].phone,
                        checked: data[key].status == 1 ? true : false
                    });

                    if (data[key].status == 1) {
                        cont.selected_phones.push('' + data[key].phone + '');
                    }
                }
            }, function (errorText) {
                console.log(errorText);
            });
        },
        get_coordinates: function get_coordinates(coordinates) {
            var regEx = /\d+[\.,]?\d*/g;
            var coord_array = [];
            //если в координаты ничего не записано, возвращаем как есть
            if (coordinates == '') {
                return coordinates;
            }
            //из полученной строки получаем массив чисел,
            //с помощью регулярки + меняем запятые на точки при парсинге
            else {
                    coord_array = coordinates.match(regEx).map(function (coordinate) {
                        return parseFloat(coordinate.replace(',', '.'));
                    });
                    if (coord_array.length == 2) {
                        return JSON.stringify({ "type": "Point", "coordinates": coord_array });
                    } else {
                        var j = 0;
                        var tube_coords = [];
                        for (var i = 0; i < coord_array.length; i++) {
                            tube_coords[j] = [];
                            tube_coords[j][0] = coord_array[i++];
                            tube_coords[j][1] = coord_array[i];
                            j++;
                        }
                        return JSON.stringify({ "type": "LineString", "coordinates": tube_coords });
                    }
                }
        }
    }
};


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu_component_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_page0_login_component_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_page1_tubes_component_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_page2_modems_component_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_page3_users_component_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_page4_addmodem_component_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_page5_notifications_component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_page6_phones_component_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_onewire_component__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_auth_component_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__main_template_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_i18n_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_main_js__ = __webpack_require__(48);
//if (window.location.protocol != "https:") {
//	window.location.protocol = "https";
//}


















Vue.use(__WEBPACK_IMPORTED_MODULE_12__plugins_main_js__["a" /* default */]);
Vue.use(vFlagIcons);

var router = new VueRouter({
  routes: [{
    path: "/",
    redirect: "/Page1_tubes"
  }, {
    path: "/Page1_tubes",
    component: __WEBPACK_IMPORTED_MODULE_2__components_page1_tubes_component_js__["a" /* Page1_tubes */],
    name: "Трубы"
  }, {
    path: "/Page2_modems",
    component: __WEBPACK_IMPORTED_MODULE_3__components_page2_modems_component_js__["a" /* Page2_modems */],
    name: "Модемы"
  }, {
    path: "/Page3_users",
    component: __WEBPACK_IMPORTED_MODULE_4__components_page3_users_component_js__["a" /* Page3_users */],
    name: "Пользователи"
  }, {
    path: "/Page4_addmodem",
    component: __WEBPACK_IMPORTED_MODULE_5__components_page4_addmodem_component_js__["a" /* Page4_addmodem */],
    name: "Добавить модем"
  }, {
    path: "/Page5_notifications",
    component: __WEBPACK_IMPORTED_MODULE_6__components_page5_notifications_component_js__["a" /* Page5_notifications */],
    name: "Уведомления"
  }, {
    path: "/Page6_phones",
    component: __WEBPACK_IMPORTED_MODULE_7__components_page6_phones_component_js__["a" /* Page6_phones */],
    name: "Список телефонов"
  }, {
    path: "/OneWireData",
    component: __WEBPACK_IMPORTED_MODULE_8__components_onewire_component__["a" /* OneWireData */],
    name: "Данные OneWire"
  }, {
    path: "/login",
    component: __WEBPACK_IMPORTED_MODULE_1__components_page0_login_component_js__["a" /* Page0_login */],
    name: "Вход"
  }]
});
Vue.config.devtools = true;
new Vue({
  el: "#app",
  components: {
    "menu-bar": __WEBPACK_IMPORTED_MODULE_0__components_menu_component_js__["a" /* Menu */],
    auth: __WEBPACK_IMPORTED_MODULE_9__components_auth_component_js__["a" /* Auth */]
  },
  i18n: __WEBPACK_IMPORTED_MODULE_11__plugins_i18n_js__["a" /* i18n */],
  router: router,
  template: __WEBPACK_IMPORTED_MODULE_10__main_template_js__["a" /* MainTemplate */],
  data: function data() {
    return {
      logged: true,
      pu: __WEBPACK_IMPORTED_MODULE_11__plugins_i18n_js__["a" /* i18n */]
    };
  },
  mounted: function mounted() {
    this.chechAuth();
    setInterval(this.chechAuth, globalConstants.loginRefreshInterval);
  },

  methods: {
    setLocale: function setLocale(locale) {
      var cont = this;
      this.$i18n.locale = locale;
    },
    chechAuth: function chechAuth() {
      if (this.logged)
        // Если мы залогинены или первый запуск, проверяем авторизацию
        this.logged = this.$logged();
    },
    loginResult: function loginResult(result) {
      this.logged = result;
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(3);


var Menu = {
	template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */],
	methods: {
		setLocale: function setLocale(locale) {
			// console.log('меняю');
			this.$emit("setLocale", locale);
		}
	}
};



/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<nav>\n<router-link to=\"Page1_tubes\">{{$t('nav.tubes')}}</router-link>\n<router-link to=\"OneWireData\">{{$t('nav.oneWireData')}}</router-link>\n<router-link to=\"Page2_modems\">{{$t('nav.modems')}}</router-link>\n<router-link to=\"Page3_users\">{{$t('nav.users')}}</router-link>\n<router-link to=\"Page4_addmodem\">{{$t('nav.addModem')}}</router-link>\n<router-link to=\"Page5_notifications\">{{$t('nav.messages')}}</router-link>\n<router-link to=\"Page6_phones\">{{$t('nav.telList')}}</router-link>\n<router-link to=\"/login\" class=\"logout\">{{$t('nav.signOut')}}</router-link>\n\n<b-dropdown id=\"lang\" dropleft class=\"\" size=\"sm\" variant=\"link\" no-caret>\n    <template v-slot:button-content>\n       <vf-icon :country=\"$t('general.langType')\"/> {{$t('general.lang')}}\n    </template>\n    <b-dropdown-item href=\"#\" @click=\"setLocale('ru')\"><vf-icon country=\"ru\"/> {{this.$i18n.messages.ru.general.lang}}</b-dropdown-item>\n    <b-dropdown-item href=\"#\" @click=\"setLocale('gb')\"><vf-icon country=\"gb\"/> {{this.$i18n.messages.gb.general.lang}}</b-dropdown-item>\n</b-dropdown>\n\n\n</nav>";



/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Page0_login; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(5);


var Page0_login = {
	template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */],
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		this.$clearLogin();
	}
};



/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "";



/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Page1_tubes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__left_menu_component_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__info_window_component_js__ = __webpack_require__(10);




var Page1_tubes = {
	name: 'Page1_tubes',
	components: {
		'left-menu': __WEBPACK_IMPORTED_MODULE_1__left_menu_component_js__["a" /* Left_menu */],
		'info-window': __WEBPACK_IMPORTED_MODULE_2__info_window_component_js__["a" /* Info_window */]
	},
	template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */],
	data: function data() {
		return {
			tubes: [], // массив труб
			intervalID: null, // Индикатор таймера для аякса
			map: null,
			selectedTube: null
		};
	},
	computed: {
		tubesComputed: function tubesComputed() {
			return this.tubes;
		},
		infoClass: function infoClass() {
			return this.selectedTube ? "show-info" : "full-map";
		}
	},

	created: function created() {
		var cont = this;
		// Первый запуск - рисуем карту
		this.getTubes(true);

		// при загрузке запускаем периодический аякс
		this.intervalID = setInterval(this.getTubes, globalConstants.tubeRefreshInterval);
	},
	beforeDestroy: function beforeDestroy() {
		// при выходе - убиваем таймер аякса
		clearInterval(this.intervalID);
	},
	mounted: function mounted() {},


	methods: {
		tubeClick: function tubeClick(tube) {
			var cont = this;
			if (this.selectedTube) {
				this.selectedTube.layer.setStyle(this.selectedTube.layer.originalStyle);
			}
			this.selectedTube = tube; // info_window увидит это, и отрисует график

			this.selectedTube.layer.setStyle({ color: "#0000ff" });

			var tId = setInterval(function () {
				cont.map.invalidateSize(); //пересчитать размер во время раскрытия окна
			}, 20);

			setTimeout(function () {
				clearInterval(tId); //останавливаем пересчет
				//перелетаем к слою
				//				cont.map.flyTo(tube.layer.getBounds().getCenter(), 17, {
				//					animate: true,
				//					duration: 1.5
				//				})
				cont.map.flyTo([JSON.parse(tube.tubeData.marker).coordinates[1], JSON.parse(tube.tubeData.marker).coordinates[0]], 17, {
					animate: true,
					duration: 1.5
				});
				//рисуем график

			}, 550);
		},
		paintHeat: function paintHeat() {
			//временное решение для демонстрации
			var cont = this;
			console.log('heatmap');
			var heat = L.heatLayer([[53.91297454740858, 27.5777, 1], [53.9132, 27.5777, 1], [53.9131, 27.5777, 1], [53.9131, 27.5775, 1], [53.91312937310582, 27.57738947868347, 0.5], [53.91297454740858, 27.577480673789978, 0.7], [53.9142, 27.57738947868347, 0.6], [53.9141, 27.57738947868347, 0.3], [53.9140, 27.57738947868347, 0.2], [53.9142, 27.5771, 0.6], [53.9141, 27.5771, 0.6], [53.9139, 27.5786, 0.4], [53.9139, 27.5788, 0.4], [53.9140, 27.5789, 0.4]], { radius: 30, blur: 30 }).addTo(cont.map);
		},
		getTubes: function getTubes(firstRun) {
			//console.log('get tube data');
			var cont = this;
			//запускаем аякс из плагина
			this.$API('static_data', 'tubes', {}, function (data) {
				if (firstRun) {
					// если превый запуск - рисуем карту
					//сама карта
					cont.map = L.map('mapid').setView(globalConstants.initialCoordinates, 13);
					// по нажатию скрываем инфоокно и убираем выделение линий
					cont.map.on('click', function () {
						//скрываем инфоокно
						if (cont.selectedTube) {
							//возвращаем стиль
							cont.selectedTube.layer.setStyle(cont.selectedTube.layer.originalStyle);
						}
						cont.selectedTube = null; // ничего не выбрано, заодно график удалится
						//пересчитать размер во время раскрытия окна, костыль для лефалета
						var tId = setInterval(function () {
							cont.map.invalidateSize();
						}, 20);
						setTimeout(function () {
							clearInterval(tId); //останавливаем пересчет
						}, 550);
					});
					//добавляем подложку
					cont.map.baseLayer = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGFyeWFjaHlydWsiLCJhIjoiY2swbzEwNnlrMDViYzNrcXI4NDAyN2gyNiJ9.d5mwHr6_wkJRtV0aXZv7Mg', {
						attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
						maxZoom: 18,
						id: 'mapbox/streets-v11',
						accessToken: 'pk.eyJ1IjoiZGFyeWFjaHlydWsiLCJhIjoiY2swbzEwNnlrMDViYzNrcXI4NDAyN2gyNiJ9.d5mwHr6_wkJRtV0aXZv7Mg'
					}).addTo(cont.map);

					// рисуем подложку тепловизора, временное решение
					cont.paintHeat();
				}

				//прогоняем массив, вернувшийся по апи
				data.some(function (el) {
					var newElement = {
						tubeData: el //выделяем данные в отдельное свойство нового элементы, чтобы за раз проверить не подмешивая свойства Vue
					};
					// найдем индекс элемента по имени трубы
					var checkElementIndex = cont.tubes.findIndex(function (element) {
						return element.tubeData.tube_name == newElement.tubeData.tube_name;
					});
					if (checkElementIndex == -1) // если нет такого элемента
						{
							var owtv = "";
							var owpv = "";

							if (newElement.tubeData.onewire_t) {
								owtv = newElement.tubeData.onewire_t;
							}
							if (newElement.tubeData.onewire_p && newElement.tubeData.onewire_p.length) {
								var owp = JSON.parse(newElement.tubeData.onewire_p);
								owpv = owp[0] / globalConstants.pressureUnits[globalConstants.pressureUnitIndex].ratio;
								owpv = owpv.toFixed(3);
							}
							// координаты линии и маркера берем из АПИ
							var layerGeometry = [JSON.parse(newElement.tubeData.coordinates), JSON.parse(newElement.tubeData.marker)];
							// свет от состояния изоляции и провода
							var color = cont.$getColorTemp(newElement.tubeData.isol);
							var style = { 'color': color };
							// добавляем ссылку на слой в элемент и сразу слой на карту
							newElement.layer = L.geoJSON(layerGeometry, {
								style: style
							}).addTo(cont.map);
							// сохраяем этот стиль
							newElement.layer.originalStyle = style;
							// содержимое маркера
							var html = "<DIV class='marker-shape' style='border-color:" + color + "' title='" + +newElement.tubeData.full_serial + "'>" + (newElement.tubeData.isol == "0" ? "🚫︎&nbsp;" : "") + ( //отрисуем символ, если проблемы с изоляцией
							newElement.tubeData.wire == "0" ? "⚡︎&nbsp;" : "") + ( //отрисуем символ, если проблемы с проводом
							newElement.tubeData.too_old ? "⏰&nbsp;" : "") + //отрисуем символ, если показания старые
							newElement.tubeData.tube_name + " " + (owtv == "" ? "" : "=") + owtv + (owtv == "" ? "" : " ℃") + (owpv == "" ? "" : "=") + owpv + (owpv == "" ? "" : globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit) +
							//								((!newElement.tubeData.too_old) &&
							//									this.selected.tubeData.onewire_t.length &&
							//									Array.isArray(JSON.parse(this.selected.tubeData.onewire_t)) ? JSON.parse(newElement.tubeData.onewire_t)[0] : "") +
							"</div>";
							// а теперь проверяем слой, первый элемент - линия, второй - точка, точке меняем контент маркера
							newElement.layer.eachLayer(function (layer) {
								if (layer.feature.geometry.type == 'Point') {
									layer.setIcon(new L.DivIcon({
										className: 'station-marker',
										html: html
									}));
								}
							});
							// и обратную ссылку, чтобы можно было по слою найти данные
							newElement.layer.linkToData = newElement;
							//клик на слой - тоже самое, тчо клик в таблице
							newElement.layer.on('click', function (e) {
								L.DomEvent.stopPropagation(e); // нам не нужно, чтобы отработал клик на карет
								cont.tubeClick(this.linkToData);
							});
							cont.tubes.push(newElement); //добавим в массив труб
							//если данные в АПИ отличаются от сохраненных данных, то перерисовываем все подряд
						} else if (JSON.stringify(cont.tubes[checkElementIndex].tubeData) != JSON.stringify(newElement.tubeData)) //или данные в нем поменялись
						{
							var owtv = "";
							var owpv = "";

							if (newElement.tubeData.onewire_t) {
								owtv = newElement.tubeData.onewire_t;
							}
							if (newElement.tubeData.onewire_p && newElement.tubeData.onewire_p.length) {
								var owp = JSON.parse(newElement.tubeData.onewire_p);
								owpv = owp[0] / globalConstants.pressureUnits[globalConstants.pressureUnitIndex].ratio;
								owpv = owpv.toFixed(3);
							}
							console.log('tube data updated', newElement.tubeData);
							cont.tubes[checkElementIndex].layer.clearLayers(); // чистим геометрию
							//перезаписываем ее// координаты линии и маркера
							var layerGeometry = [JSON.parse(newElement.tubeData.coordinates), JSON.parse(newElement.tubeData.marker)];
							cont.tubes[checkElementIndex].layer.addData(layerGeometry);
							//меняем цвет
							var color = cont.$getColorTemp(newElement.tubeData.isol);
							var style = { 'color': color };
							cont.tubes[checkElementIndex].layer.setStyle(style);
							//							newElement.layer.originalStyle = style;
							var html = "<DIV class='marker-shape' style='border-color:" + color + "' title='" + +newElement.tubeData.serial + "'>" + (newElement.tubeData.wire == "0" ? "🚫&nbsp;" : "") + newElement.tubeData.tube_name + " " + (owtv == "" ? "" : "=") + owtv + (owtv == "" ? "" : " ℃") + (owpv == "" ? "" : "=") + owpv + (owpv == "" ? "" : globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit) + "</div>";
							cont.tubes[checkElementIndex].layer.eachLayer(function (layer) {
								if (layer.feature.geometry.type == 'Point') {
									layer.setIcon(new L.DivIcon({
										className: 'station-marker',
										html: html
									}));
								}
							});
							cont.tubes[checkElementIndex].tubeData = newElement.tubeData;
						}
				});
			}, function (errorText) {
				console.log(errorText);
			});
		}
	}

};



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div :class=\"infoClass\">\n\t<left-menu :tubes=\"tubesComputed\" @line-click=\"tubeClick\"></left-menu>\n\t<div id=\"mapid\"></div>\n\t<info-window v-if=\"selectedTube\" :selected=\"selectedTube\"></info-window>\n</div>\n";



/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Left_menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(9);


var Left_menu = {
	data: function data() {
		return {
			perPage: globalConstants.linesPerPageLeftMenu,
			currentPage: 1,
			filter: null,
			curr_tube: null,
			fields: [{
				key: 'wire',
				label: ''
			}, {
				key: 'tubeData.tube_name',
				label: this.$t('tubes.tube'),
				sortable: true
			},
			// {
			// 	key: 'tubeData.battery',
			// 	label: '🔋, %',
			// 	sortable: true
			// },

			{
				key: 'isol',
				label: ''
			}, {
				key: 'tubeData.isol',
				label: 'Ω',
				sortable: true
			}]

		};
	},

	computed: {
		menuRows: function menuRows() {
			return this.tubes.length;
		}
	},
	updated: function updated() {
		this.fields[1].label = this.$t('tubes.tube');
	},

	props: {
		tubes: Array
	},
	methods: {
		rowClass: function rowClass(item, type) {
			// console.log('rowClass', item);
			if (!item || type !== 'row') return;
			if (item.tubeData.tube_name == this.curr_tube) return 'left-menu-table_active';
		},
		isolStyle: function isolStyle(item) {
			return {
				'background-color': this.$getColorTemp(item.tubeData.isol),
				'width': 90 * item.tubeData.isol / 100 + 10 + '%'
			};
		},
		tubeListClick: function tubeListClick(record, index) {
			// 'record' will be the row data from items
			// `index` will be the visible row number (available in the v-model 'shownItems')
			// console.log('aaa',record); // This will be the item data for the row
			this.curr_tube = record.tubeData.tube_name;
			this.rowClass();
			this.$emit("line-click", record);
		},
		wireIcons: function wireIcons(item) {
			var icons = '';
			icons += item.tubeData.wire == '0' ? '⚡︎' : '';
			icons += item.tubeData.isol == '0' ? '🚫' : '';
			icons += item.tubeData.too_old ? '⏰' : '';
			//TODO: check if this is really "alarm*" and s_alarm = 0, tet on real devices
			//TODO: "alarm1" should show icons only on modem "_A", "alarm2" -> "_B"
			// icons += (item.tubeData.reason.includes("alarm")&&(item.tubeData.s_alarm == '0') ? '💦' : '');
			icons += item.tubeData.s_alarm == '0' ? item.tubeData.reason.includes("alarm") ? '💦' : '💧' : '';
			//		if (icons == '') icons = '✅';
			return icons;
		},
		filterTable: function filterTable(row, filter) {
			this.currentPage = 1;
			return !!row.tubeData.tube_name.toLowerCase().includes(filter.toLowerCase());
		}
	},
	template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */]
};



/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div>\n<div  class=\"left-menu\">\n\t<b-form-input class='input-dark' v-model=\"filter\" :placeholder=\"$t('general.search')\"></b-form-input>\n  \n<div  class=\"left-menu-table\">\n\n    <b-table\n      id=\"tubes-table\"\n      :filter=\"filter\"\n      :items=\"tubes\"\n      :per-page=\"perPage\"\n      :current-page=\"currentPage\"\n      :fields=\"fields\"\n      :tbody-tr-class=\"rowClass\"\n      :filter-function=\"filterTable\"\n      striped\n      borderless\n      \n      small\n      hover\n      dark\n  \t\t@row-clicked=\"tubeListClick\"\n    >\n     \t<template v-slot:cell(wire)=\"data\">\n       \t\t{{ wireIcons(data.item) }} \n      \t</template>\n \t  \t<template v-slot:cell(isol)=\"data\">\n        \t<div class='isol-box'>\n        \t\t<div class='isol-inner-box' v-bind:style=\"isolStyle(data.item)\">\n                    <div>{{ data.item.tubeData.norm }}</div>\n                </div>\n        \t</div>\n        </template>\n    </b-table>\n  </div>\n\n      <b-pagination\n      v-model=\"currentPage\"\n      :total-rows=\"menuRows\"\n      :per-page=\"perPage\"\n      aria-controls=\"tubes-table\"\n      first-text = \"\u23EE\"\n      prev-text = \"\u23EA\"\n      next-text = \"\u23E9\"\n      last-text = \"\u23ED\"\n    ></b-pagination>\n  </div>    \n</div>";



/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Info_window; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(11);


var Info_window = {
  data: function data() {
    return {
      chart: {},
      dataPoints: [],
      newComment: "",

      periodDays: 2,
      startDate: new Date(new Date() - 1 * 24 * 60 * 60 * 1000).toISOString().substring(0, 10),
      endDate: new Date().toISOString().substring(0, 10),
      periods: 60,
      image: null
    };
  },


  props: {
    selected: Object

  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    isAdmin: function isAdmin() {
      return localStorage.group == 'admin';
    },
    onFileChange: function onFileChange(e) {
      var _this = this;

      var cont = this;
      //			console.log(this.$refs.fileInput.value);
      // достаем список файлов из ивента
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      //			console.log(files[0]);
      // чтение контента
      var reader = new FileReader();
      reader.onload = function (e) {
        //результат - img в виде data:image/jpeg;base64,/9j/4AAQSkZJRgABA.. - готов к использованию даже в адресной строке
        //				console.log(e.target.result);
        //чистим
        cont.$refs.fileInput.value = "";
        //var exif = EXIF.readFromBinaryFile(new BinaryFile(e.target.result));
        //сохраняем
        _this.$API("static_data", "updateImage", {
          serial: _this.selected.tubeData.serial,
          picture: e.target.result
        }, function (data) {
          cont.image = e.target.result;
          alert("Ok");
        }, function () {});
      };
      reader.readAsDataURL(files[0]);
    },
    getPhones: function getPhones(selected) {
      var phones = "";
      for (var key in selected.tubeData.phones) {
        phones += selected.tubeData.phones[key].phone + "\n";
      }

      console.log(selected.tubeData.phones);
      console.log(phones);
      return phones;
    },
    updateComment: function updateComment() {
      var cont = this;
      //сохраняем комментарий
      this.$API("static_data", "updateComment", {
        tube_name: this.selected.tubeData.tube_name,
        comment: this.newComment
      }, function (data) {
        cont.selected.tubeData.tube_comment = cont.newComment; //если запрос прошел, записываем переменную, чтобы пропала кнопка сохранения
      }, function () {});
    },
    fillChart: function fillChart(data, begin, end, titleY, suffixY, dataName, yValueFormat) {
      var cont = this;

      data.some(function (el) {
        el.x = new Date(el.x * 1000);
      });
      cont.dataPoints = data;
      //let interval = Math.round((end - begin) / 1000 / 60 / 60);
      CanvasJS.addCultureInfo("ru", {
        decimalSeparator: ".",
        digitGroupSeparator: ",",
        shortMonths: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"]
      });
      cont.chart = new CanvasJS.Chart("chartContainer", {
        theme: "dark2", // "light2", "dark1", "dark2"
        animationEnabled: false, // change to true
        zoomEnabled: true,
        culture: cont.$i18n.locale === "ru" ? "ru" : "en",

        axisX: {
          //				valueFormatString: "DD/MM",
          minimum: begin,
          maximum: end
          //				interval: interval,
          //				intervalType: "hour"
        },
        axisY: {
          title: titleY,
          prefix: "",
          suffix: suffixY,
          minimum: 0,
          //					maximum: 1800,
          includeZero: true
        },
        toolTip: {
          shared: true
        },
        legend: {
          cursor: "pointer",
          verticalAlign: "bottom",
          horizontalAlign: "center",
          dockInsidePlotArea: false,
          itemclick: cont.toogleDataSeries
        },
        data: [{
          type: "line", //spline
          axisYType: "primary",
          xValueType: "dateTime",
          xValueFormatString: "DD/MM/YYYY HH:mm",
          name: dataName,
          showInLegend: true,
          color: "#ffff00",
          markerSize: 4,
          markerType: "circle",
          yValueFormatString: yValueFormat,
          connectNullData: false,
          dataPoints: cont.dataPoints
        }],
        rangeChanging: function rangeChanging(e) {
          //zoom, get new data
          //console.log("type : " + e.type + ", trigger : " + e.trigger + ", AxisX viewportMininum : " + e.axisX[0].viewportMinimum + ",AxisX viewportMaximum : " + e.axisX[0].viewportMaximum);
        }
      });

      cont.chart.render();
    },
    toogleDataSeries: function toogleDataSeries(e) {
      if (typeof e.dataSeries.visible === "undefined" || e.dataSeries.visible) {
        e.dataSeries.visible = false;
      } else {
        e.dataSeries.visible = true;
      }
      this.chart.render();
    },
    changeRange: function changeRange(days) {
      this.periodDays = days;
      this.startDate = new Date(new Date() - (days - 1) * 24 * 60 * 60 * 1000).toISOString().substring(0, 10);
      this.endDate = new Date().toISOString().substring(0, 10);
    },
    getArchiveData: function getArchiveData(begin, end) {
      var cont = this;
      if (this.selected) {
        var api = "archive";
        var titleY = cont.$t("tubes.isolResistance");
        var suffixY = cont.$t("tubes.kOhm");
        var dataName = cont.$t("tubes.isol");
        var yValueFormat = "### " + cont.$t("tubes.kOhm");

        // if(this.selected.tubeData.onewire_t && this.selected.tubeData.onewire_t.length){
        if (this.selected.tubeData.onewire_t != "") {
          api = "onewire_t";
          titleY = cont.$t("modems.temperature");
          suffixY = cont.$t("modems.temperatureUnit");
          dataName = cont.$t("modems.onewire");
          yValueFormat = "#,##0.## " + cont.$t("modems.temperatureUnit");
        }

        if (this.selected.tubeData.onewire_p && this.selected.tubeData.onewire_p.length) {
          api = "onewire_p";
          titleY = cont.$t("modems.pressure");
          suffixY = globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit;
          dataName = cont.$t("modems.onewireP");
          yValueFormat = "#,##0.##  " + globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit;
        }

        var periodBegin = new Date(cont.startDate).getTime() / 1000;
        var periodEnd = new Date(cont.endDate).getTime() / 1000 + 60 * 60 * 24;
        //посчитаем период, если он заканчивается сегодня
        var today = new Date().toISOString().substring(0, 10);
        if (cont.endDate == today) {
          var diffTime = periodEnd - periodBegin;
          var diffDays = Math.ceil(diffTime / (60 * 60 * 24));
          this.periodDays = diffDays;
        } else {
          this.periodDays = 0;
        }

        cont.$API("static_data", api, {
          serial: this.selected.tubeData.serial,
          begin: periodBegin,
          end: periodEnd,
          periods: this.periods
        }, function (data) {
          cont.fillChart(data, (periodBegin + new Date().getTimezoneOffset() * 60) * 1000, (periodEnd + new Date().getTimezoneOffset() * 60) * 1000, titleY, suffixY, dataName, yValueFormat);
        }, function () {});
      } else cont.chart.clear();
    },
    getImage: function getImage() {
      var cont = this;
      if (this.selected) {
        cont.image = null;

        cont.$API("static_data", "getImage", {
          serial: this.selected.tubeData.serial
        }, function (data) {
          cont.image = data.picture;
        }, function () {});
      } else cont.chart.clear();
    },
    openImage: function openImage() {
      //			window.open().document.body.innerHTML = "<img style='max-width:100%;max-height:100%' src='" + this.image +"'>";
      window.open().document.write("<html><body style='width:100%;height:100%'><img style='max-width:100%;max-height:100%' src='" + this.image + "'></body></html>");
    }
  },
  watch: {
    locale: function locale() {
      this.getArchiveData();
    },

    selected: {
      handler: function handler() {
        this.getArchiveData();
        this.getImage();
        this.newComment = this.selected.tubeData.tube_comment;
      },

      immediate: true
    },
    startDate: function startDate() {
      this.getArchiveData();
    },
    endDate: function endDate() {
      this.getArchiveData();
    }
  },

  template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */]
};



/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div class=\"info-window\">\n<div class='tube-info'>\n<table >\n  <tr>\n  \t<td class='label'>{{$t('tubes.tube')}}</td> \n\t<td class='label'>{{$t('tubes.modem')}}</td>\n  </tr>\n  <tr>\n    <td class='value'>{{ selected.tubeData.tube_name }}</td>\n    <td class='value'>{{ selected.tubeData.serial.substring(0,25) }}{{ selected.tubeData.serial.substring(25,26)? '...': '' }}</td>\n  </tr>\n  <tr>\n\t<td class='label'>{{$t('tubes.serialNumber')}}</td>\n\t<td class='label'>{{$t('tubes.activity')}}</td>\n  </tr>\n  <tr>\n\t<td class='value'> {{ selected.tubeData.full_serial  }}</td>\n\t<td class='value'> {{ selected.tubeData.too_old ? '\u23F0' : '' }}{{ selected.tubeData.measure_time  }}</td>\n  </tr>\n\n<!--  <tr>\n\t<td class='label'>{{$t('tubes.isol')}}</td>\n\t<td class='label'>{{$t('tubes.battery')}}</td>\n  </tr>\n  <tr>\n    <td class='value'>{{ selected.tubeData.isol == 0 ? '\uD83D\uDEAB' : '' }}{{ selected.tubeData.isol }}% / {{ selected.tubeData.isol_value }} {{$t('tubes.kOhm')}}</td>\n    <td class='value'>{{ selected.tubeData.battery }}%</td>\n  </tr>\n  <tr>\n\t<td class='label'>{{$t('tubes.wire')}}</td>\n\t<td class='label'>{{$t('tubes.phones')}}</td>\n  </tr>\n  <tr>\n\t<td class='value'>{{ selected.tubeData.wire == 0 ? '\u26A1\uFE0E' : '' }} {{ selected.tubeData.wire }}% / {{ selected.tubeData.wire_value }} {{$t('tubes.ohm')}}</td>\n\t<td class='value'>{{getPhones(selected)}}</td>\n  </tr>-->\n  <tr>\n\t<td class='label'>{{$t('tubes.coordinates')}}</td>\n\t<td class='label' v-if=\"image\">\n\t\t<a href=\"#\" v-on:click='openImage'>{{$t('tubes.photo')}}</a>\n\t</td>\n\t<td class='label' v-else>\n\t\t{{$t('tubes.photo')}}\t\t\n\t</td>\n  </tr>\n  <tr>\n    <td class='value'>{{ JSON.parse(selected.tubeData.marker).coordinates[0].toFixed(4) }}, {{ JSON.parse(selected.tubeData.marker).coordinates[1].toFixed(4) }}</td>\n    <td>\n      <input id=\"fileTag\"\n\t    type=\"file\"\n            v-on:change=\"onFileChange\"\n            v-show=\"isAdmin()\"\n\t    ref=\"fileInput\"\n\t    accept=\"image/*\"\n          />\n\t</td>\n  </tr>\n</table>\n<div class=\"saveButtonWrapper\">\n    <span>{{$t('tubes.comment')}}</span>\n    <button class=\"input-dark form-control\" v-on:click=\"updateComment\" :disabled='!(selected.tubeData.tube_comment != newComment)' >{{$t('tubes.saveComment')}}</button>\n</div>\n\n<textarea class=\"input-dark form-control\" v-model='newComment' :placeholder=\"$t('tubes.enterComment')\"></textarea>\n</div>  \n<div class='chart'>\n  <div class=\"date-range\">\n    <button class=\"input-dark form-control\" v-bind:class=\"{ range_active: periodDays == 365 }\" v-on:click=\"changeRange(365)\">{{$t('tubes.year')}}</button>\n    <button class=\"input-dark form-control\" v-bind:class=\"{ range_active: periodDays == 183 }\" v-on:click=\"changeRange(183)\">{{$t('tubes.halfYear')}}</button>\n    <button class=\"input-dark form-control\" v-bind:class=\"{ range_active: periodDays == 30 }\" v-on:click=\"changeRange(30)\">{{$t('tubes.days30')}}</button>\n    <button class=\"input-dark form-control\" v-bind:class=\"{ range_active: periodDays == 10 }\" v-on:click=\"changeRange(10)\">{{$t('tubes.days10')}}</button>\n    <button class=\"input-dark form-control\" v-bind:class=\"{ range_active: periodDays == 2 }\" v-on:click=\"changeRange(2)\">{{$t('tubes.days2')}}</button>\n    <button class=\"input-dark form-control\" v-bind:class=\"{ range_active: periodDays == 1 }\" v-on:click=\"changeRange(1)\">{{$t('tubes.day1')}}</button>\n    \n    <input class=\"input-dark form-control\" type=\"date\" v-model=\"startDate\">\n    <input class=\"input-dark form-control\" type=\"date\" v-model=\"endDate\">\n\n  </div>\n\n<div id=\"chartContainer\" ></div>\n\n</div>  \n</div>";



/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Page2_modems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__left_menu_component_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__info_window_component_js__ = __webpack_require__(16);




var Page2_modems = {
  name: "Page2_modems",
  components: {
    "left-menu": __WEBPACK_IMPORTED_MODULE_1__left_menu_component_js__["a" /* Left_menu */],
    "info-window": __WEBPACK_IMPORTED_MODULE_2__info_window_component_js__["a" /* Info_window */]
  },
  template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */],
  data: function data() {
    return {
      modems: [],

      selectedModem: null,

      selectedModemLogs: {}
    };
  },

  created: function created() {
    // Первый запуск
    this.getModems();
  },
  beforeDestroy: function beforeDestroy() {
    // при выходе - убиваем таймер аякса
    clearInterval(this.intervalID);
  },

  methods: {
    modemClick: function modemClick(modem) {
      this.selectedModem = modem; // info_window увидит это, и отрисует график
    },
    getModems: function getModems() {
      var _this = this;

      //запускаем аякс из плагина
      this.$API("static_data", "modems", {}, function (data) {
        _this.modems = data;
      }, function (errorText) {
        console.log(errorText);
      });
    },
    onSelectedDataLoad: function onSelectedDataLoad(data) {
      this.selectedModemLogs = data;
    }
  }
};



/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "\n<div class=\"page-content\">\n\t<left-menu :modems=\"modems\" @line-click=\"modemClick\" :selectedModemLogs=\"selectedModemLogs\"></left-menu>\n\t\n\t<info-window v-if=\"selectedModem\" :selected=\"selectedModem\" @data-load=\"onSelectedDataLoad\"></info-window>\n</div>";



/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Left_menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(15);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var Left_menu = {
  props: {
    modems: Array,
    selectedModemLogs: Object
  },
  components: {
    "ag-grid-vue": window.agGridVue.AgGridVue
  },
  data: function data() {
    return {
      perPage: globalConstants.linesPerPageLeftMenu,
      selectedModem: null,
      newComment: null,
      fields: [{
        field: "wire",
        headerName: ""
      }, {
        field: "serial",
        headerName: this.$t("modems.sN"),
        sortable: true,
        filter: true,
        flex: 1
      }]
    };
  },
  updated: function updated() {
    this.fields[1].label = this.$t("modems.sN");
  },

  computed: {
    transformedModemRows: function transformedModemRows() {
      return this.modems.map(function (m) {
        return _extends({}, m, {
          wire: m.too_old ? "⏰" : "",
          serial: m.serial.length > 35 ? m.serial.slice(0, 35) + "..." : m.serial.slice(0, 35)
        });
      });
    },
    modemInfoFields: function modemInfoFields() {
      if (this.selectedModem) return [{ label: "IMEI", value: this.selectedModemLogs.IMEI }, { label: "IMSI", value: this.selectedModemLogs.IMSI }, { label: "ICCID", value: this.selectedModemLogs.ICCID }, { label: "NUM", value: this.selectedModemLogs.num }, { label: "UTC", value: this.selectedModemLogs.UTC }, {
        label: this.$t("modems.activity"),
        value: (this.selectedModem.too_old && "⏰") + " " + this.selectedModem.measure_time
      }, { label: this.$t("modems.modem"), value: this.selectedModem.serial }];
    }
  },
  methods: {
    onFirstDataRendered: function onFirstDataRendered() {
      this.gridColumnApi.autoSizeColumn("wire");
    },
    onGridReady: function onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onModemChanged: function onModemChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      this.selectedModem = selectedRows[0];
      this.newComment = selectedRows[0].comment;
      this.$emit("line-click", selectedRows[0].serial.includes("...") ? this.modems.find(function (m) {
        return m.serial.includes(selectedRows[0].serial);
      }) : selectedRows[0].serial);
    },
    updateComment: function updateComment() {
      var _this = this;

      //сохраняем комментарий
      this.$API("static_data", "updateModemComment", {
        serial: this.selectedModem.serial,
        comment: this.newComment
      }, function () {
        _this.selectedModem.comment = _this.newComment; //если запрос прошел, записываем переменную, чтобы пропала кнопка сохранения
      }, function () {});
    }
  },
  template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */]
};



/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "\n<div class=\"left-menu-modems\">\n  <ag-grid-vue\n    class=\"ag-theme-balham-dark ag-theme-rtube left-menu-modems__top\"\n    :columnDefs=\"fields\"\n    :rowData=\"transformedModemRows\"\n    pagination=\"true\"\n    :paginationPageSize=\"perPage\"\n    rowSelection=\"single\"\n    @first-data-rendered=\"onFirstDataRendered\"\n    @grid-ready=\"onGridReady\"\n    @selection-changed=\"onModemChanged\">\n  </ag-grid-vue>\n  \n  <div class=\"left-menu-modems__bottom\" v-show=\"selectedModem\">\n    <h2>{{selectedModemLogs.dev ?? \"123\"}}</h2>\n    <div>\n      <p class=\"current-modem-item\" v-for=\"field in modemInfoFields\">\n        <span>{{field.label}}</span>\n        <b>{{field.value}}</b>\n      </p>\n    </div>\n    <div class=\"saveButtonWrapper\">\n        <span>{{$t('modems.comment')}}</span>\n        <button class=\"input-dark form-control\" :disabled=\"!(newComment!==selectedModem?.comment&&newComment!=='')\" @click=\"updateComment\">{{$t('modems.saveComment')}}</button>\n    </div>\n    <textarea class=\"input-dark form-control\" :placeholder=\"$t('modems.enterComment')\" v-model=\"newComment\"></textarea>\n  </div>\n</div>";



/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Info_window; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(17);


function onewirePresureValueGetter(params) {
  var pressure = params.data.payload.Telemetry.onewireP;
  if (pressure != undefined) {
    return pressure / globalConstants.pressureUnits[globalConstants.pressureUnitIndex].ratio;
  }
  return '';
}

var Info_window = {
  components: {
    "ag-grid-vue": window.agGridVue.AgGridVue
  },
  props: {
    selected: String
  },
  data: function data() {
    return {
      perPage: 60,
      periodDays: 10,
      startDate: this.getRangeDate(10),
      endDate: this.getRangeDate(1),
      periods: 60,
      dataLogs: [],
      fields: [{
        field: "received",
        headerName: this.$t("modems.receivingTime")
      }, {
        field: "",
        headerName: this.$t("modems.messageReason"),
        sortable: true
      }, {
        field: "",
        headerName: this.$t("modems.formationTime")
      }, {
        field: "",
        headerName: this.$t("modems.temperature")
      }],
      dateRanges: [{
        label: this.$t("modems.year"),
        value: 365
      }, {
        label: this.$t("modems.halfYear"),
        value: 183
      }, {
        label: this.$t("modems.days30"),
        value: 30
      }, {
        label: this.$t("modems.days10"),
        value: 10
      }, {
        label: this.$t("modems.days2"),
        value: 2
      }, {
        label: this.$t("modems.day1"),
        value: 1
      }]
    };
  },


  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    }
  },

  updated: function updated() {
    this.dateRanges[0].label = this.$t("modems.year");
    this.dateRanges[1].label = this.$t("modems.halfYear");
    this.dateRanges[2].label = this.$t("modems.days30");
    this.dateRanges[3].label = this.$t("modems.days10");
    this.dateRanges[4].label = this.$t("modems.days2");
    this.dateRanges[5].label = this.$t("modems.day1");
  },


  methods: {
    getRangeDate: function getRangeDate(days) {
      var date = new Date();
      date.setDate(date.getDate() - days + 1);
      return date.toISOString().slice(0, 10);
    },
    changeRange: function changeRange(days) {
      this.periodDays = days;
      this.startDate = this.getRangeDate(days);
      this.endDate = this.getRangeDate(1);
    },
    onDateRangeChange: function onDateRangeChange() {
      this.periodDays = null;
    },
    getModemLogs: function getModemLogs() {
      var _this = this;

      var periodBegin = new Date(this.startDate).getTime() / 1000;
      var periodEnd = new Date(this.endDate).getTime() / 1000 + 60 * 60 * 24;

      this.$API("static_data", "modem_logs", {
        serial: this.selected,
        begin: periodBegin,
        end: periodEnd,
        periods: this.periods
      }, function (data) {
        data.forEach(function (element) {
          element.received = new Date(element.received.replace(/\s/, "T") + "Z").toLocaleString("af-ZA", {
            timeZone: "Europe/Minsk"
          });

          element.payload.Telemetry.UTC = new Date(element.payload.Telemetry.UTC * 1000).toLocaleString("af-ZA", {
            timeZone: "Europe/Minsk"
          });
        });

        _this.dataLogs = data;

        _this.dataLogs[0].payload.Message.UTC = new Date(_this.dataLogs[0].payload.Message.UTC * 1000).toLocaleString("af-ZA", { timeZone: "Europe/Minsk" });

        _this.$emit("data-load", _this.dataLogs[0].payload.Message);

        var nameFields = [];

        nameFields.push({
          field: "received",
          headerName: _this.$t("modems.receivingTime"),
          resizable: true,
          width: 145,
          filter: true,
          sortable: true
        });
        nameFields.push({
          field: "payload.Telemetry.UTC",
          headerName: _this.$t("modems.formationTime"),
          resizable: true,
          width: 170,
          filter: true,
          sortable: true
        });
        nameFields.push({
          field: "payload.Telemetry.reason",
          headerName: _this.$t("modems.messageReason"),
          sortable: true,
          filter: true,
          resizable: true,
          width: 130
        });
        nameFields.push({
          field: "payload.Telemetry.s_alarm1",
          headerName: "s_alarm1",
          sortable: true,
          filter: true,
          width: 90
        });
        nameFields.push({
          field: "payload.Telemetry.s_alarm2",
          headerName: "s_alarm2",
          sortable: true,
          filter: true,
          width: 90
        });

        for (var key1 in _this.dataLogs[0].payload) {
          for (var key2 in _this.dataLogs[0].payload[key1]) {
            if (key1 != "Message") {
              var str = "payload." + key1 + "." + key2;
              switch (key2) {
                case "UTC":
                case "bat":
                case "temp":
                case "reason":
                case "s_alarm1":
                case "s_alarm2":
                  break;
                case "onewire":
                  // nameFields.push({
                  //   field: str,
                  //   headerName: this.$t("modems.onewire"),
                  //   width: 150,
                  //   resizable: false,
                  // });
                  break;
                case "onewireP":
                  // nameFields.push({
                  //   field: str,
                  //   headerName: `${this.$t("modems.onewireP")} (${globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit})`,
                  //   width: 165,
                  //   resizable: false,
                  //   valueGetter: onewirePresureValueGetter,
                  //   valueFormatter: params => {
                  //     const value = Number(params.value);
                  //     return isNaN(value) ? '' : value.toFixed(3);
                  //   }
                  // });
                  break;
                default:
                  nameFields.push({
                    field: str,
                    headerName: key2,
                    width: 76,
                    resizable: false
                  });
              }
            }
          }
        };

        nameFields.push({
          field: "payload.Telemetry.onewire",
          headerName: _this.$t("modems.onewire"),
          width: 150,
          resizable: false
        });

        nameFields.push({
          field: "payload.Telemetry.onewireP",
          headerName: _this.$t("modems.onewireP") + " (" + globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit + ")",
          width: 165,
          resizable: false,
          valueGetter: onewirePresureValueGetter,
          valueFormatter: function valueFormatter(params) {
            var value = Number(params.value);
            return isNaN(value) ? '' : value.toFixed(3);
          }
        });

        nameFields.push({
          field: "payload.Telemetry.bat",
          headerName: "bat",
          width: 45
        });
        nameFields.push({
          field: "payload.Telemetry.temp",
          headerName: _this.$t("modems.temperature"),
          width: 100
        });

        _this.fields = nameFields;
      }, function () {});
    }
  },
  watch: {
    locale: function locale() {
      this.getModemLogs();
    },

    selected: {
      handler: function handler() {
        this.getModemLogs();
      },

      immediate: true
    },
    startDate: function startDate() {
      this.getModemLogs();
    },
    endDate: function endDate() {
      this.getModemLogs();
    }
  },
  template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */]
};



/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "\n<div class=\"right-info-modems\">\n  <div class=\"date-range\">\n    <button class=\"input-dark form-control\" v-for=\"date in dateRanges\" v-bind:class=\"{ range_active: periodDays == date.value }\" @click=\"changeRange(date.value)\">{{date.label}}</button>\n    \n    <input class=\"input-dark form-control\" type=\"date\" v-model=\"startDate\" @change=\"onDateRangeChange\">\n    <input class=\"input-dark form-control\" type=\"date\" v-model=\"endDate\" @change=\"onDateRangeChange\">\n  </div>\n  <div class=\"modem-info-logs\">\n    <ag-grid-vue\n      class=\"ag-theme-balham-dark ag-theme-rtube\"\n      :columnDefs=\"fields\"\n      :rowData=\"dataLogs\"\n      pagination=\"true\"\n      :paginationPageSize=\"perPage\">\n    </ag-grid-vue>\n  </div>\n</div>";



/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Page3_users; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__left_menu_component_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__info_window_component_js__ = __webpack_require__(22);




var Page3_users = {
	name: 'Page3_users',
	components: {
		'left-menu': __WEBPACK_IMPORTED_MODULE_1__left_menu_component_js__["a" /* Left_menu */],
		'info-window': __WEBPACK_IMPORTED_MODULE_2__info_window_component_js__["a" /* Info_window */]
	},
	template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */],
	data: function data() {
		return {
			users: [],

			selectedUser: null
		};
	},

	created: function created() {
		var cont = this;
		// Первый запуск 
		this.getUsers();
	},
	beforeDestroy: function beforeDestroy() {
		// при выходе - убиваем таймер аякса
		//clearInterval(this.intervalID);
	},
	mounted: function mounted() {},


	methods: {
		updateUser: function updateUser(user) {
			var cont = this;
			if (user.delete) {
				cont.users.find(function (el, index) {
					if (el.name == user.name) {
						//						delete cont.users[index];
						cont.$delete(cont.users, index);
						cont.selectedUser = cont.users.find(function () {
							return true;
						});
						return true;
					}
				});
			} else {
				if (user.mode == 'edit') {

					this.selectedUser.name = user.name;
					this.selectedUser.email = user.email;
					this.selectedUser.group = user.group;
					this.selectedUser.phone = user.phone;
					this.selectedUser.notification1 = user.notification1;
					this.selectedUser.notification2 = user.notification2;
				} else {
					var newUser = {};
					newUser.name = user.name;
					newUser.email = user.email;
					newUser.group = user.group;
					newUser.phone = user.phone;
					newUser.notification1 = user.notification1;
					newUser.notification2 = user.notification2;
					this.users.push(newUser);
					this.selectedUser = newUser;
				}
			}
		},
		userClick: function userClick(user) {
			var cont = this;

			this.selectedUser = user; // info_window увидит это, и отрисует график
		},
		getUsers: function getUsers() {
			//console.log('get tube data');
			var cont = this;
			//запускаем аякс из плагина
			this.$API('users', 'usersList', {}, function (data) {
				cont.users = data;
				if (data[0]) cont.selectedUser = data[0];
			}, function (errorText) {
				console.log(errorText);
			});
		}
	}

};



/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div>\n\t<left-menu :users=\"users\" @line-click=\"userClick\"></left-menu>\n\t\n\t<info-window v-if = \"selectedUser\" :selected=\"selectedUser\" @update-user=\"updateUser\" ></info-window>\n</div>\n";



/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Left_menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(21);


var Left_menu = {
	data: function data() {
		return {
			perPage: globalConstants.linesPerPageLeftMenu,
			currentPage: 1,
			filter: null,
			fields: [{
				key: 'name',
				label: '',
				sortable: true
			}]

		};
	},

	computed: {
		menuRows: function menuRows() {
			return this.users.length;
		},
		rowClass: function rowClass() {}
	},
	props: {
		users: Array
	},
	methods: {
		userListClick: function userListClick(record, index) {
			console.log(record);
			this.$emit("line-click", record);
		},
		wire: function wire(item) {
			var icons = '';

			icons += item.too_old ? '⏰' : '';
			//		if (icons == '') icons = '✅';
			return icons;
		},
		shortSerial: function shortSerial(item) {
			if (item.serial) return item.serial.substring(0, 15) + (item.serial.substring(15, 16) ? '...' : '');
		}
	},
	template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */]
};



/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div>\n<div  class=\"left-menu\">\n\t<b-form-input class='input-dark' v-model=\"filter\" :placeholder=\"$t('general.search')\"></b-form-input>\n  \n<div  class=\"left-menu-table\">\n\n    <b-table\n      id=\"left-table\"\n      :filter=\"filter\"\n      :items=\"users\"\n      :per-page=\"perPage\"\n      :current-page=\"currentPage\"\n      :fields=\"fields\"\n      :tbody-tr-class=\"rowClass\"\n\n      striped\n      borderless\n      \n      small\n      hover\n      dark\n  \t\t@row-clicked=\"userListClick\"\n    >\n        \n \t  \t\n    </b-table>\n  </div>\n\n      <b-pagination\n      v-model=\"currentPage\"\n      :total-rows=\"menuRows\"\n      :per-page=\"perPage\"\n      aria-controls=\"left-table\"\n            first-text=\"\u23EE\"\n      prev-text=\"\u23EA\"\n      next-text=\"\u23E9\"\n      last-text=\"\u23ED\"\n    ></b-pagination>\n  </div>    \n</div>";



/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Info_window; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(23);


var Info_window = {
	data: function data() {
		return {

			mode: 'view',
			user: null
		};
	},


	props: {
		selected: Object

	},
	methods: {
		edit: function edit() {
			this.mode = 'edit';
		},
		create: function create() {
			this.mode = 'create';
			this.user = { name: '', email: '', group: 'user' };
		},
		save: function save() {
			var cont = this;
			this.user.mode = this.mode;
			this.$API('users', 'updateUser', this.user, function (data) {
				if (data.result) {
					cont.$emit("update-user", cont.user);

					cont.mode = 'view';
				}
			}, function (errorText) {
				console.log(errorText);
			});
		},
		del: function del() {
			if (confirm("Вы точно хотите удалить пользователя?")) {
				var cont = this;
				this.user.mode = this.mode;
				this.user.delete = true;
				this.$API('users', 'deleteUser', this.user, function (data) {
					if (data.result) {
						cont.$emit("update-user", cont.user);

						cont.mode = 'view';
					}
				}, function (errorText) {
					console.log(errorText);
				});
			}
		},
		cancel: function cancel() {
			this.mode = 'view';
			this.user = JSON.parse(JSON.stringify(this.selected));
		}
	},
	watch: {

		'selected': {
			handler: function handler() {
				this.user = JSON.parse(JSON.stringify(this.selected));
			},

			immediate: true
		}
	},
	template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */]
};



/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div class=\"modem-info-window\">\n<div class='user-info'>\n<table >\n\n  <tr>\n    <td class='label'>{{$t('users.login')}}</td>\n    <td class='value'>\n      <input class=\"input-dark\" type='text' v-model=user.name :readonly=\"(mode=='view')||(mode=='edit')\" > \n      <div v-if=\"mode!='view'\"><div class=\"red\" v-if=\"(!user.name)\">{{$t('users.enterLogin')}}</div></div><br>\n    </td>\n  </tr>\n    <tr>\n    <td class='label' valign=\"top\">{{$t('users.password')}}<br>\n    \n\n    </td>\n    <td class='value'>\n      <input class=\"input-dark\" type='text' v-model=user.password1 :readonly=\"mode=='view'\" > \n      <div v-if=\"mode=='edit'\"><div v-if=\"((!user.password1)&&(!user.password2))\">{{$t('users.unchanged')}}</div></div>\n      <div v-if=\"mode=='create'\"><div class=\"red\" v-if=\"((!user.password1)||(!user.password2))\">{{$t('users.enterPassword')}}</div></div><br>\n      <input class=\"input-dark\" type='text' v-model=user.password2 :readonly=\"mode=='view'\" > <div class=\"red\" v-if=\"(user.password1!=user.password2)\">{{$t('users.dontMatch')}}</div>\n    </td>\n  </tr>\n  <tr>\n    <td class='label'>{{$t('users.email')}}</td>\n    <td class='value'>\n      <input class=\"input-dark\" type='email' v-model=user.email :readonly=\"mode=='view'\"> \n      <div v-if=\"mode!='view'\"><div class=\"red\" v-if=\"!(user.email.indexOf('@') > -1)\">{{$t('users.incorrectEmail')}}</div></div><br>\n    </td>\n  </tr>\n  <tr>\n    <td class='label' valign=\"top\">{{$t('users.group')}}</td>\n    <td class='value'>\n\n      <input type=\"radio\" id=\"two\" value=\"user\" v-model=\"user.group\"  :disabled=\"mode=='view'\">\n      <label for=\"two\" v-bind:class=\"{ bold: user.group=='user' }\">{{$t('users.user')}}</label>\n      <br>\n      <input type=\"radio\"  id=\"one\" value=\"admin\" v-model=\"user.group\"  :disabled=\"mode=='view'\">\n      <label for=\"one\" v-bind:class=\"{ bold: user.group=='admin' }\">{{$t('users.admin')}}</label>\n    </td>\n  </tr>\n  <tr>\n    <td class='label'>{{$t('users.phone')}}</td>\n    <td class='value'>\n      <input class=\"input-dark\" type='tel' v-model=user.phone :readonly=\"mode=='view'\"> \n      <div v-if=\"mode!='view'\"><div class=\"red\" v-if=\"user.phone!=parseInt(user.phone)\">{{$t('users.phoneFormat')}}</div></div>\n      \n    </td>\n  </tr>\n  <tr>\n    <td class='label'>{{$t('users.checkbox1')}}</td>\n    <td class='value'>\n      <input class=\"input-dark\" type='checkbox' v-model=user.notification1 :readonly=\"mode=='view'\"> \n    </td>\n  </tr>\n  <tr>\n    <td class='label'>{{$t('users.checkbox2')}}</td>\n    <td class='value'>\n      <input class=\"input-dark\" type='checkbox' v-model=user.notification2 :readonly=\"mode=='view'\"> \n    </td>\n  </tr>\n  \n</table>\n<button class=\"input-dark\" v-on:click=\"edit\" v-show=\"mode=='view'\">{{$t('users.edit')}}</button>\n<button class=\"input-dark\" v-on:click=\"create\" v-show=\"mode=='view'\">{{$t('users.create')}}</button>\n<button class=\"input-dark\" v-on:click=\"del\" v-show=\"(mode=='view')&&(user.name!='admin')\">{{$t('users.delete')}}</button>\n<button class=\"input-dark\" v-on:click=\"save\" v-show=\"(mode=='edit')||(mode=='create')\">{{$t('users.save')}}</button>\n<button class=\"input-dark\" v-on:click=\"cancel\" v-show=\"(mode=='edit')||(mode=='create')\">{{$t('users.cancel')}}</button>\n\n</div> \n</div>";



/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div>\n<left-menu :tubes=\"tubes\" :phones=\"phones\" @updateTubeList=getTubes></left-menu>\n<form-window :phones=\"phones\" :selected_phones=\"selected_phones\" @updateTubeList=getTubes></form-window>\n</div>";


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Left_menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_js__ = __webpack_require__(0);



var Left_menu = {
  data: function data() {
    return {
      perPage: globalConstants.linesPerPageLeftMenu,
      currentPage: 1,
      filter: null,
      fields: [{
        key: "tube_name",
        label: this.$t("addModem.tube"),
        sortable: true
      }, {
        key: "serial",
        label: this.$t("addModem.modemsSN"),
        sortable: true
      }, {
        key: "action",
        label: ""
      }, {
        key: "delete",
        label: ""
      }],
      options: [{
        key: "serial",
        namelabel: this.$t("addModem.serNumber"),
        typefield: "text",
        info: ""
      }, {
        key: "full_serial",
        namelabel: this.$t("addModem.fullSerNumber"),
        typefield: "text",
        info: ""
      }],
      comment_types: [{
        key: "tube_comment",
        namelabel: this.$t("addModem.tubeComment"),
        typefield: "text",
        info: ""
      }, {
        key: "modem_comment",
        namelabel: this.$t("addModem.modemComment"),
        type: "text",
        info: ""
      }],
      selected_phones: [],
      tube_coords: null,
      modem_coords: null,
      editing_tube: null,
      map: null,
      line: null,
      marker: null,
      message: "",
      coords: ''
    };
  },

  props: {
    tubes: Array,
    phones: Array
  },

  computed: {
    menuRows: function menuRows() {
      return this.tubes.length;
    },
    rowClass: function rowClass() {}
  },
  updated: function updated() {
    this.fields[0].label = this.$t("addModem.tube");
    this.fields[1].label = this.$t("addModem.modemsSN");
    this.options[0].namelabel = this.$t("addModem.serNumber");
    this.options[1].namelabel = this.$t("addModem.fullSerNumber");
  },

  methods: {
    showModal: function showModal(item) {
      var cont = this;
      function createContForEdit() {
        return new Promise(function (resolve, reject) {
          cont.$refs["EditModal"].show();
          cont.editing_tube = item;
          cont.options[0].info = item.serial;
          cont.options[1].info = item.full_serial;
          cont.coords = JSON.stringify(JSON.parse(item.marker).coordinates);
          cont.comment_types[0].info = item.tube_comment;
          cont.comment_types[1].info = item.modem_comment;
          cont.selected_phones = [];
          cont.tube_coords = JSON.parse(item.coordinates);
          cont.modem_coords = JSON.parse(item.marker);
          for (var key in item.phones) {
            cont.selected_phones.push("" + item.phones[key].phone + "");
          }
          resolve("success");
        });
      }
      var promise = createContForEdit();
      promise.then(function (result) {
        cont.tube_coords = JSON.parse(item.coordinates);
        cont.map = L.map("map", { editable: true }).setView([cont.tube_coords.coordinates[0][1], cont.tube_coords.coordinates[0][0]], 17);
        setTimeout(function () {
          cont.map.invalidateSize();
        }, 40);
        cont.map.baseLayer = L.tileLayer("https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoiZGFyeWFjaHlydWsiLCJhIjoiY2swbzEwNnlrMDViYzNrcXI4NDAyN2gyNiJ9.d5mwHr6_wkJRtV0aXZv7Mg", {
          attribution: "&copy",
          maxZoom: 18,
          id: "mapbox.streets",
          accessToken: "pk.eyJ1IjoiZGFyeWFjaHlydWsiLCJhIjoiY2swbzEwNnlrMDViYzNrcXI4NDAyN2gyNiJ9.d5mwHr6_wkJRtV0aXZv7Mg"
        }).addTo(cont.map);
      }).then(function () {
        var latlngcoords = [];
        for (var i = 0; i < cont.tube_coords.coordinates.length; i++) {
          latlngcoords[i] = [];
          latlngcoords[i][0] = cont.tube_coords.coordinates[i][1];
          latlngcoords[i][1] = cont.tube_coords.coordinates[i][0];
        }
        cont.line = L.polyline(latlngcoords).addTo(cont.map);
        cont.line.enableEdit();

        var latlngmarker = [];
        latlngmarker[0] = cont.modem_coords.coordinates[1];
        latlngmarker[1] = cont.modem_coords.coordinates[0];
        cont.marker = L.marker(latlngmarker).addTo(cont.map);
        cont.marker.enableEdit();
      });
    },
    editModemTube: function editModemTube() {
      var cont = this;
      cont.editing_tube.serial = cont.options[0].info;
      cont.editing_tube.full_serial = cont.options[1].info;
      cont.editing_tube.tube_comment = cont.comment_types[0].info;
      cont.editing_tube.modem_comment = cont.comment_types[1].info;
      var new_phones = [];
      for (var i = 0; i < cont.selected_phones.length; i++) {
        new_phones[i] = { phone: cont.selected_phones[i] };
      }
      cont.editing_tube.phones = JSON.stringify(new_phones);

      var new_coordinates = [];
      for (var _i = 0; _i < cont.line._latlngs.length; _i++) {
        new_coordinates[_i] = [];
        new_coordinates[_i][0] = cont.line._latlngs[_i].lng;
        new_coordinates[_i][1] = cont.line._latlngs[_i].lat;
      }

      var new_marker = [];
      new_marker[0] = cont.marker._latlng.lng;
      new_marker[1] = cont.marker._latlng.lat;

      cont.editing_tube.coordinates = JSON.stringify({
        type: "LineString",
        coordinates: new_coordinates
      });

      // cont.editing_tube.marker = JSON.stringify({
      //   type: "Point",
      //   coordinates: new_marker,
      // });
      cont.editing_tube.marker = __WEBPACK_IMPORTED_MODULE_1__component_js__["a" /* Page4_addmodem */].methods.get_coordinates(cont.coords);

      this.$API("modems", "editModemTube", cont.editing_tube, function (data) {
        if (data.element == "absent") {
          cont.message = "Изменяемый модем отсутствует либо используется на другом участке!";
        } else {
          cont.message = "Участок успешно отредактирован!";
        }
        cont.showMessage();
        cont.editing_tube = null;
      }, function (errorText) {
        console.log(errorText);
      });
    },
    hideModal: function hideModal() {
      this.$emit("updateTubeList");
      this.$refs["EditModal"].hide();
    },
    showMessage: function showMessage() {
      this.$refs["messageModal"].show();
    },
    hideMessage: function hideMessage() {
      this.$refs["messageModal"].hide();
      this.hideModal();
    },
    showDeleteModal: function showDeleteModal(item) {
      this.message = "Вы действительно хотите удалить участок?";
      this.editing_tube = null;
      this.editing_tube = item;
      this.$refs["deleteModal"].show();
    },
    hideDeleteModal: function hideDeleteModal() {
      this.$refs["deleteModal"].hide();
    },
    deleteTube: function deleteTube() {
      var cont = this;
      this.$API("modems", "deleteModemTube", cont.editing_tube, function (data) {
        cont.$emit("updateTubeList");
      }, function (errorText) {
        console.log(errorText);
      });
      this.hideDeleteModal();
    }
  },
  template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */]
};



/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div>\n<div  class=\"menu-tube\">\n\t<b-form-input class='input-dark' v-model=\"filter\" :placeholder=\"$t('general.search')\"></b-form-input>\n  \n<div  class=\"menu-tube-table\">\n\n    <b-table\n      id=\"left-table\"\n      :filter=\"filter\"\n      :items=\"tubes\"\n      :per-page=\"perPage\"\n      :current-page=\"currentPage\"\n      :fields=\"fields\"\n      :tbody-tr-class=\"rowClass\"\n      striped\n      borderless\n      hover\n      dark\n    >\n    <template v-slot:cell(action)=\"data\">\n        <b-button class=\"icons\" v-on:click=\"showModal(data.item)\"><img src=\"css/edit.svg\"></b-button>\n        </template>\n\n        <template v-slot:cell(delete)=\"data\">\n        <b-button v-on:click=\"showDeleteModal(data.item)\" class=\"icons\"><img src=\"css/delete.svg\"></b-button>\n        </template>\n    </b-table>\n\n  </div>\n      <b-pagination\n      v-model=\"currentPage\"\n      :total-rows=\"menuRows\"\n      :per-page=\"perPage\"\n      aria-controls=\"left-table\"\n      first-text = \"\u23EE\"\n      prev-text = \"\u23EA\"\n      next-text = \"\u23E9\"\n      last-text = \"\u23ED\"\n    ></b-pagination>\n  </div>\n\n  <div class=\"edit-tube-modal\">\n  <b-modal size=\"lg\"\n  ref=\"EditModal\" hide-footer\n    header-bg-variant=\"dark\"\n    header-text-variant=\"light\"\n    :title=\"$t('addModem.editTubeData')\">\n    <b-row>\n    <b-col>\n      <b-form-group label-for=\"name-input\">\n        <b-col v-for=\"field in options\" v-bind:key=\"field.id\">\n            <label>{{field.namelabel}}</label>\n            <b-form-input\n                v-model=\"field.info\">\n            </b-form-input>\n        </b-col>\n        <b-col>\n            <label for=\"input-live\">{{$t('addModem.modemCoords')}}</label>\n            <b-form-input\n            trim\n            placeholder=\"27.68925, 53.94542\"\n            v-model=\"coords\">\n            </b-form-input>\n        </b-col>\n       \n        <b-col>\n        <label>{{$t('addModem.editContacts')}}</label>\n        <b-form-checkbox-group \n          class=\"contacts\"\n          v-model=\"selected_phones\"\n          :options=\"phones\"\n          stacked>\n        </b-form-checkbox-group>\n        </b-col>\n\n      </b-form-group>\n      \n    </b-col>\n\n    <b-col>\n    <div id=\"map\" class=\"hidden\"> </div>\n     <b-col v-for=\"comment_type in comment_types\" v-bind:key=\"comment_type.id\">\n            <label for=\"input-live\">{{comment_type.namelabel}}</label>\n            <b-form-textarea\n                v-model=\"comment_type.info\"\n                :type=\"comment_type.typefield\"\n                :placeholder=\"$t('addModem.enterComment')\"\n            ></b-form-textarea>\n        </b-col>\n    </b-col>\n\n    </b-row>\n    <b-row> \n        <b-col><b-button class=\"\" block variant=\"dark\" @click=\"hideModal\">{{$t('general.cancel')}}</b-button></b-col>\n        <b-col></b-col>\n        <b-col><b-button class=\"\" block variant=\"success\" @click=\"editModemTube()\">{{$t('general.edit')}}</b-button></b-col>\n    </b-row>\n  </b-modal>\n  </div>\n\n  <b-modal header-bg-variant=\"dark\"\n    header-text-variant=\"light\" \n    ref=\"messageModal\" \n    hide-footer \n    title=\"\u0421\u0442\u0430\u0442\u0443\u0441 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430:\">\n\n      <div class=\"d-block text-center\">\n        <h4>{{message}}</h4>\n      </div>\n      <b-button class=\"mt-3\" variant=\"outline-danger\" block \n      v-on:click=\"hideMessage\">\u0425\u043E\u0440\u043E\u0448\u043E</b-button>\n</b-modal>\n\n<b-modal\nref=\"deleteModal\" hide-footer\n  header-bg-variant=\"dark\"\n  header-text-variant=\"light\"\n  title=\"\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0443\u0447\u0430\u0441\u0442\u043A\u0430 \u0442\u0440\u0443\u0431\u044B\">\n  \n  <div>\n        <h5>{{message}}</h5>\n  </div>\n    <b-button class=\"mt-3\" block variant=\"success\" @click=\"deleteTube()\">\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u043B\u0435\u043C\u0435\u043D\u0442</b-button>\n    <b-button class=\"mt-3\" block variant=\"dark\" @click=\"hideDeleteModal()\">\u041E\u0442\u043C\u0435\u043D\u0430</b-button>\n</b-modal>\n\n</div>";



/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Form_window; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__qrCode_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_js__ = __webpack_require__(0);




var Form_window = {
    name: 'Form_window',

    template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */],

    data: function data() {
        return {
            selected_phone: [],
            phones_array: [],
            message: '',
            modem: null,
            description: '',
            description_coords: '',
            types: [{
                key: 'serial',
                info: '',
                typefield: 'text',
                namelabel: this.$t('addModem.serialNumber')
            }, {
                key: 'full_serial',
                info: '',
                typefield: 'text',
                namelabel: this.$t('addModem.fullSerial')
            }, {
                key: 'tube_name',
                info: '',
                typefield: 'text',
                namelabel: this.$t('addModem.tubeName')
            }],
            comment_types: [{
                info: '',
                typefield: 'text',
                namelabel: this.$t('addModem.modemComment')
            }, {
                info: '',
                typefield: 'text',
                namelabel: this.$t('addModem.tubeComment')
            }],

            modem_coords: '[27.6845492,53.94454554]',
            tube_coords: '[27.6845492,53.94454554] [27.68945452,53.94454542]'
        };
    },
    created: function created() {
        this.selected_phone = this.selected_phones;
        //qrCode();
    },
    destroyed: function destroyed() {
        //stopQR();
    },


    computed: {
        validModem: function validModem() {
            for (var i = 0; i < this.types.length; i++) {
                if (!this.validInput(this.types[i].info)) {
                    return true;
                }
            }
            if (!this.validCoords(this.modem_coords) || !this.validCoords(this.tube_coords)) {
                return true;
            } else if (this.selected_phone.length == 0) {
                return true;
            } else {
                return false;
            }
        }
    },
    updated: function updated() {
        this.types[0].namelabel = this.$t('addModem.serialNumber');
        this.types[1].namelabel = this.$t('addModem.fullSerial');
        this.types[2].namelabel = this.$t('addModem.tubeName');
        this.comment_types[0].namelabel = this.$t('addModem.modemComment');
        this.comment_types[1].namelabel = this.$t('addModem.tubeComment');
    },

    props: {
        tubes: Array,
        phones: Array,
        selected_phones: Array
    },

    methods: {
        validInput: function validInput(element) {
            this.description = this.$t('addModem.message1');
            return element.length > 0 ? true : false;
        },


        //при вводе проверяем валидность координат, чтобы при отправке формы не было записано null
        validCoords: function validCoords(element) {
            var regEx = /\d+[\.,]?\d*/g;
            if (element != '') {
                if (element.match(regEx) != null) {
                    return true;
                }
                //если введены некоректные данные
                else {
                        this.description_coords = this.$t('addModem.message2');
                        return false;
                    }
            } else {
                return true;
            }
        },


        //методы для всплывающего окна сообщения
        showModal: function showModal() {
            this.$refs['messageModal'].show();
        },
        hideModal: function hideModal() {
            this.$emit('updateTubeList');
            this.$refs['messageModal'].hide();
        },


        //добавляем модем без очистки полей
        createAndContinue: function createAndContinue() {
            var cont = this;
            this.modem = { serial: this.types[0].info,
                full_serial: this.types[1].info,
                tube_name: this.types[2].info,
                modem_comment: this.comment_types[0].info,
                tube_comment: this.comment_types[1].info,
                type: 'NB-IOT',
                modem_coordinates: __WEBPACK_IMPORTED_MODULE_2__component_js__["a" /* Page4_addmodem */].methods.get_coordinates(this.modem_coords),
                tube_coordinates: __WEBPACK_IMPORTED_MODULE_2__component_js__["a" /* Page4_addmodem */].methods.get_coordinates(this.tube_coords),
                phones: this.get_phones()
            };

            var message3 = this.$t('addModem.message3');
            var message4 = this.$t('addModem.message4');
            this.$API('modems', 'addModemTube', this.modem, function (data) {
                if (data.element == "exist") {
                    cont.message = message3;
                } else {
                    cont.message = message4;
                }
                cont.showModal();
            }, function (errorText) {
                console.log(errorText);
            });
        },


        //метод добавления с очисткой полей от данных
        createAndDelete: function createAndDelete() {
            this.createAndContinue();
            //чистим поля
            this.types.forEach(function (element) {
                element.info = '';
            });
        },
        get_phones: function get_phones() {
            this.phones_array;
            for (var i = 0; i < this.selected_phone.length; i++) {
                this.phones_array[i] = { "phone": this.selected_phone[i] };
            }
            return JSON.stringify(this.phones_array);
        },
        checkAllPhones: function checkAllPhones() {
            this.selected_phone = [];
            for (var key in this.phones) {
                this.selected_phone.push(this.phones[key].value);
            }
        },
        deleteAllPhones: function deleteAllPhones() {
            this.selected_phone = [];
        }
    }
};


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div>\n<div class=\"adding-window\">\n<h1>{{$t('addModem.addModemh1')}}</h1>\n\n<b-tabs content-class=\"mt-3\">\n\n<b-tab :title=\"$t('addModem.manually')\">\n\n<div class=\"info\">\n<div class=\"info-form\">\n<template>\n  <b-container fluid>\n  <b-row >\n  <b-col sm=\"6\" v-for=\"type in types\">\n    <label for=\"input-live\">{{type.namelabel}}</label>\n    <b-form-input\n      v-bind:id=\"type.key\"\n      v-model=\"type.info\"\n      :state=\"validInput(type.info)\"\n      trim\n    ></b-form-input>\n    <b-form-invalid-feedback id=\"input-live-feedback\">\n    {{description}}\n    </b-form-invalid-feedback>\n    </b-col>\n\n    <b-col sm=\"6\" class=\"hidden\">\n            <img id='qr-code' src=''>\n            <label class=\"qr-label\">{{$t('addModem.scanQR')}} <br>\n              <a id=\"qrScannerLink\" href=''>{{$t('addModem.qrLink')}}.</a>\n            </label>\n      </b-col>\n\n    </b-row>\n\n    <b-row >\n    <b-col sm=\"6\" v-for=\"comment_type in comment_types\" v-bind:key=\"comment_type.id\">\n    <label for=\"input-live\">{{comment_type.namelabel}}</label>\n    <b-form-textarea\n    v-model=\"comment_type.info\"\n    :type=\"comment_type.typefield\"\n    :placeholder=\"$t('addModem.enterComment')\"\n  ></b-form-textarea>\n  </b-col>\n  </b-row>\n\n  <b-row>\n  <b-col sm=\"6\">\n  <label for=\"input-live\">{{$t('addModem.modemCoords')}}</label>\n    <b-form-input\n      :state=\"validCoords(modem_coords)\"\n      trim\n      placeholder=\"27.68925, 53.94542\"\n      v-model=\"modem_coords\">\n      </b-form-input>\n    <b-form-invalid-feedback id=\"input-live-feedback\">\n      {{description_coords}}\n    </b-form-invalid-feedback>\n    </b-col>\n\n  <b-col sm=\"6\">\n  <label for=\"input-live\">{{$t('addModem.tubeCoords')}}</label>\n    <b-form-input\n    :state=\"validCoords(tube_coords)\"\n      trim\n      v-model=\"tube_coords\"\n      placeholder=\"[27.6892,53.9454] [27.6892,53.94542]\"\n    ></b-form-input>\n    <b-form-invalid-feedback id=\"input-live-feedback\">\n      {{description_coords}}\n    </b-form-invalid-feedback>\n    </b-col>\n  </b-row>\n\n\n  <b-row >\n  <b-col>\n    <label>{{$t('addModem.addContacts')}}</label>\n    <b-form-checkbox-group \n    class=\"contacts\"\n    v-model=\"selected_phone\"\n    :options=\"phones\"\n    stacked>\n    </b-form-checkbox-group>\n  </b-col>\n  </b-row>\n  <b-row class=\"phones-button\">\n  <b-col sm=\"2.9\">\n   <b-button v-on:click=\"deleteAllPhones\">{{$t('addModem.resetAll')}}</b-button>\n   </b-col>\n   <b-col sm=\"2.9\">\n   <b-button class=\"add-modem\"\n   v-on:click=\"checkAllPhones\">{{$t('addModem.chooseAll')}}</b-button>\n   </b-col>\n  </b-row>\n  \n\n  <b-row class=\"main-button\">\n  <b-col sm=\"3\">\n  </b-col>\n  <b-col sm=\"3\">\n  </b-col>\n   <b-col sm=\"3.6\">\n   <b-button\n   :disabled=\"validModem\"\n   v-on:click=\"createAndContinue\">{{$t('addModem.addAndContinue')}}</b-button>\n   </b-col>\n   <b-col sm=\"2.4\">\n   <b-button class=\"add-modem\"\n   :disabled=\"validModem\"\n   v-on:click=\"createAndDelete\">{{$t('addModem.addModemButton')}}</b-button>\n   </b-col>\n  </b-row>\n\n  </b-container>\n</template>\n\n<b-modal body-bg-variant=\"pink\" ref=\"messageModal\" hide-footer :title=\"$t('addModem.addStatus')\">\n      <div class=\"d-block text-center\">\n        <h4>{{message}}</h4>\n      </div>\n      <b-button class=\"mt-3\" variant=\"outline-danger\" block \n      v-on:click=\"hideModal\">{{$t('addModem.ok')}}</b-button>\n</b-modal>\n</div>\n</div>\n\n</b-tab>\n\n\n\n<b-tab :title=\"$t('addModem.fromFile')\">\n<p>In process</p>\n</b-tab>\n\n</b-tabs>\n</div>\n</div>";



/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export qrCode */
/* unused harmony export stopQR */
var interval;
function qrCode() {
	if (interval) return;
	// qr-service environments
	var backendUrl = 'https://r-tube-qr-back.icdc.io';
	var token = '';
	var requestUrl = true; // change to "false" to return data without url and image
	var qrImageType = 'png';
	var cellSize = 4; // mod cellSize to change size of QR-code image
	var marginSize = 2;
	var cellColor = '343A40';
	var qrBackColor = 'FFFFFF';

	var time = new Date();
	var emptyValueTime;
	var fieldValue = '';

	interval = setInterval(function () {
		fetch(backendUrl + '/?token=' + token + '&requestUrl=' + requestUrl + '&qr_cell_size=' + cellSize + '&qr_margin=' + marginSize + '&qr_bg_color=' + qrBackColor + '&cell_color=' + cellColor + '&type=' + qrImageType).then(function (response) {
			return response.json();
		}).then(function (data) {
			token = data.token;
			// manual update text field after load value from redis 
			if (!emptyValueTime && !document.getElementById('full_serial').value && fieldValue) {
				emptyValueTime = new Date();
			};
			if (document.getElementById('qr-code').src != data.image) {
				document.getElementById('qr-code').src = data.image;
			};
			if (document.getElementById('full_serial').value != data.value && data.value && !data.error) {
				if (data.time >= time.getTime() ||
				// manual update text field after load value from redis. user can do it in ~10 (10000ms) seconds after clearing the field
				!document.getElementById('full_serial').value && emptyValueTime && time.getTime() - emptyValueTime.getTime() > 10000) {
					console.log(data);
					document.getElementById('full_serial').value = data.value;
					fieldValue = data.value;
					emptyValueTime = undefined;
				};
				time = new Date();
			}

			document.getElementById('qrScannerLink').href = data.url;
		});
	}, 1000);
}

function stopQR() {
	clearInterval(interval);
	interval = undefined;
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Page5_notifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__left_menu_component_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications_component_js__ = __webpack_require__(34);




var Page5_notifications = {
    name: 'Page5_notifications',
    components: {
        'left-menu': __WEBPACK_IMPORTED_MODULE_1__left_menu_component_js__["a" /* Left_menu */],
        'notifications': __WEBPACK_IMPORTED_MODULE_2__notifications_component_js__["a" /* Notifications */]
    },
    template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */],
    data: function data() {
        return {
            modems: []
        };
    },

    created: function created() {
        var cont = this;
        this.getModems();
    },


    methods: {
        getModems: function getModems() {
            var cont = this;
            //запускаем аякс из плагина
            this.$API('static_data', 'modems', {}, function (data) {
                cont.modems = data;
            }, function (errorText) {
                console.log(errorText);
            });
        }
    }
};


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div>\n<left-menu :modems=\"modems\"></left-menu>\n<notifications></notifications>\n</div>";


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Left_menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(33);


var Left_menu = {
	data: function data() {
		return {
			perPage: globalConstants.linesPerPageLeftMenu,
			currentPage: 1,
			filter: null,
			fields: [{
				key: 'wire',
				label: '',
				sortable: true
			}, {
				key: 'serial',
				label: this.$t('messages.sN'),
				sortable: true
			}, {
				key: 'battery',
				label: '🔋,%',
				sortable: true
			}]

		};
	},

	computed: {
		menuRows: function menuRows() {
			return this.modems.length;
		},
		rowClass: function rowClass() {}
	},
	updated: function updated() {
		this.fields[1].label = this.$t('messages.sN');
	},

	props: {
		modems: Array
	},
	methods: {
		modemListClick: function modemListClick(record, index) {
			this.$emit("line-click", record);
		},
		wire: function wire(item) {
			var icons = '';
			icons += item.too_old ? '⏰' : '';
			return icons;
		},
		shortSerial: function shortSerial(item) {
			if (item.serial) return item.serial.substring(0, 35) + (item.serial.substring(35, 36) ? '...' : '');
		}
	},
	template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */]
};



/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div>\n<div  class=\"left-menu\">\n\t<b-form-input class='input-dark' v-model=\"filter\" :placeholder=\"$t('general.search')\"></b-form-input>\n  \n<div  class=\"left-menu-table\">\n\n    <b-table\n      id=\"left-table\"\n      :filter=\"filter\"\n      :items=\"modems\"\n      :per-page=\"perPage\"\n      :current-page=\"currentPage\"\n      :fields=\"fields\"\n      striped\n      borderless\n      small\n      hover\n      dark\n  \t\t@row-clicked=\"modemListClick\"\n    >\n\n          <template v-slot:cell(serial)=\"data\"\n          >\n          {{ shortSerial(data.item)  }}\n\n        </template>\n     \t<template v-slot:cell(wire)=\"data\">\n       \t\t{{ wire(data.item) }}\n      \t</template>\n \t  \t\n    </b-table>\n  </div>\n\n      <b-pagination\n      v-model=\"currentPage\"\n      :total-rows=\"menuRows\"\n      :per-page=\"perPage\"\n      aria-controls=\"left-table\"\n            first-text=\"\u23EE\"\n      prev-text=\"\u23EA\"\n      next-text=\"\u23E9\"\n      last-text=\"\u23ED\"\n    ></b-pagination>\n  </div>    \n</div>";



/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(35);


var Notifications = {
  name: "Notifications",
  template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */],
  data: function data() {
    return {
      selectedValue: "",
      new_notifications: [],
      filters: [{
        text: this.$t("messages.break"),
        value: "wire_error"
      }, {
        text: this.$t("messages.lowBattery"),
        value: "battery_error"
      }, {
        text: this.$t("messages.sodden"),
        value: "isol_error"
      }, {
        text: this.$t("messages.noSignal"),
        value: "no_signal"
      }],

      fields: [{
        key: "icons",
        label: ""
      }, {
        key: "measure_time",
        label: this.$t("messages.time")
      }, {
        key: "serial",
        label: this.$t("messages.modemSN")
      }, {
        key: "tube_name",
        label: this.$t("messages.tube")
      }, {
        key: "message",
        label: this.$t("messages.message"),
        class: "message-column-width"
      }],
      notifications: []
    };
  },
  created: function created() {
    var cont = this;
    this.getNotifications();
  },


  computed: {
    //обновляем значения в таблице в зависимости от выбранного фильтра
    filterNotifications: function filterNotifications() {
      if (this.selectedValue == "") {
        this.new_notifications = this.notifications;
      } else {
        this.new_notifications = [];
        for (var i = 0; i < this.notifications.length; i++) {
          if (this.notifications[i].message_types[this.selectedValue] == true) {
            this.new_notifications.push(this.notifications[i]);
          }
        }
      }
      return true;
    }
  },
  updated: function updated() {
    this.filters[0].text = this.$t("messages.break");
    this.filters[1].text = this.$t("messages.lowBattery");
    this.filters[2].text = this.$t("messages.sodden");
    this.filters[3].text = this.$t("messages.noSignal");
    this.fields[1].label = this.$t("messages.time");
    this.fields[2].label = this.$t("messages.modemSN");
    this.fields[3].label = this.$t("messages.tube");
    this.fields[4].label = this.$t("messages.message");
  },


  methods: {
    resetFilters: function resetFilters() {
      this.selectedValue = "";
      return true;
    },
    getNotifications: function getNotifications() {
      var cont = this;
      this.$API("static_data", "notifications", {}, function (data) {
        cont.notifications = data;
      }, function (errorText) {
        console.log(errorText);
      });
    },
    tubeIcons: function tubeIcons(item) {
      var icons = "";
      icons += item.message_types.wire_error ? "⚡︎" : "";
      icons += item.message_types.isol_error ? "🚫" : "";
      icons += item.message_types.battery_error ? "🔋" : "";
      icons += item.message_types.no_signal ? "⏰" : "";
      return icons;
    },
    getMessage: function getMessage(item) {
      var message = "";
      message += item.message_types.wire_error ? this.$t("messages.break2") : "";
      message += item.message_types.isol_error ? this.$t("messages.sodden2") : "";
      message += item.message_types.battery_error ? this.$t("messages.lowBattery2") : "";
      message += item.message_types.no_signal ? this.$t("messages.noSignal2") : "";
      return message;
    }
  }
};


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div>\n<div class=\"notifications\">\n<div class=\"notification-table\">\n<b-table\n      :items=\"new_notifications\"\n      :fields=\"fields\"\n      :filters=\"filterNotifications\"\n      striped\n      borderless\n      small\n      hover\n      dark>\n\n        <template v-slot:cell(icons)=\"data\">\n          {{ tubeIcons(data.item) }}\n        </template>\n\n        <template v-slot:cell(message)=\"data\">\n          {{ getMessage(data.item) }}\n        </template>\n\n    </b-table>\n    </div>\n\n    <div class=\"filtration\">\n    <b-form-group :label=\"$t('messages.filterBy')\">\n      <b-form-radio-group\n      v-model=\"selectedValue\"\n      :options=\"filters\"\n      class=\"checkbox-style\"\n      stacked>\n\n      </b-form-radio-group>\n      <b-button\n      v-on:click=\"resetFilters\">{{$t('messages.resetButton')}}</b-button>\n      </b-form-group>\n    </div>\n    </div>\n    </div>";


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Page6_phones; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(37);


var Page6_phones = {
  name: "page6_phones",

  data: function data() {
    return {
      new_phone: null,
      deleting_phone: null,
      editing_phone: null,
      key_phone: null,
      strJSON: "",
      phones: [],
      fields: [{
        key: "name",
        label: this.$t("phoneList.employee")
      }, {
        key: "phone",
        label: this.$t("phoneList.phone")
      }],
      types: [{
        key: "name",
        info: "",
        typefield: "text",
        namelabel: this.$t("phoneList.employeeName")
      }, {
        key: "phone",
        info: "",
        typefield: "text",
        namelabel: this.$t("phoneList.phoneNumber")
      }, {
        key: "position",
        info: "",
        typefield: "text",
        namelabel: this.$t("phoneList.position")
      }, {
        key: "email",
        info: "",
        typefield: "text",
        namelabel: this.$t("phoneList.email")
      }],
      options: [],
      default_phone: false,
      message: ""
    };
  },
  created: function created() {
    this.getPhones();
  },


  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    }
  },

  updated: function updated() {
    this.fields[0].label = this.$t("phoneList.employee");
    this.fields[1].label = this.$t("phoneList.phone");
    this.types[0].namelabel = this.$t("phoneList.employeeName");
    this.types[1].namelabel = this.$t("phoneList.phoneNumber");
    this.types[2].namelabel = this.$t("phoneList.position");
    this.types[3].namelabel = this.$t("phoneList.email");
  },


  methods: {
    showModal: function showModal(item) {
      this.options = [];
      this.key_phone = item.phone;
      this.default_phone = false;
      this.$refs["EditModal"].show();
      this.options.push({
        key: "name",
        namelabel: this.$t("phoneList.employeeName"),
        typefield: "text",
        info: item.name
      });
      for (var key in item.info) {
        this.options.push({
          key: key,
          namelabel: this.$t("phoneList." + key),
          typefield: "text",
          info: item.info[key]
        });
      }
      this.default_phone = item.status == 1 ? true : false;
    },
    hideModal: function hideModal() {
      this.$refs["EditModal"].hide();
    },
    showCreateModal: function showCreateModal() {
      this.$refs["CreateModal"].show();
    },
    hideCreateModal: function hideCreateModal() {
      this.$refs["CreateModal"].hide();
    },
    showDeleteModal: function showDeleteModal(item) {
      this.editing_phone = item;
      this.message = "Вы действительно хотите удалть сотрудника?";
      this.$refs["deleteModal"].show();
    },
    hideDeleteModal: function hideDeleteModal() {
      this.$refs["deleteModal"].hide();
    },
    getPhones: function getPhones() {
      var cont = this;
      cont.phones = [];
      this.$API("static_data", "phones", {}, function (data) {
        cont.phones = data;
        var nameFields = [];
        // let i = 0;
        for (var key1 in data[0].info) {
          var str = "info." + key1;
          // nameFields.push({key: str, label: key1});
          nameFields.push({ key: str, label: cont.$t("phoneList." + key1) });
          // cont.fields.push(nameFields[i]);
          // cont.$set(cont.fields, cont.fields.length - 1, nameFields[i]);
          // i++;
        }
        // cont.fields.push({ key: "action", label: "" });
        // cont.fields.push({ key: "delete", label: "" });
        nameFields.push({ key: "action", label: "" });
        nameFields.push({ key: "delete", label: "" });

        cont.fields = [cont.fields[0], cont.fields[1]].concat(nameFields);
      }, function (errorText) {
        console.log(errorText);
      });
    },
    createPhone: function createPhone() {
      var cont = this;
      cont.new_phone = {
        name: cont.types[0].info,
        phone: cont.types[1].info,
        position: cont.types[2].info,
        email: cont.types[3].info,
        status: this.default_phone ? 1 : 0
      };
      cont.strJSON = JSON.stringify(cont.new_phone);
      this.types.forEach(function (element) {
        element.info = "";
      });
      this.$API("phones", "editPhones", { phone: cont.strJSON, edit_mode: "create" }, function (data) {
        cont.$emit("addPhoneToTable", cont.new_phone);
        cont.new_phone = null;
        cont.strJSON = "";
        cont.getPhones();
      }, function (errorText) {
        console.log(errorText);
      });
      this.hideCreateModal();
    },
    editPhone: function editPhone(fields) {
      var cont = this;
      this.editing_phone = {
        name: fields[0].info,
        phone: this.key_phone,
        position: fields[1].info,
        email: fields[2].info,
        status: this.default_phone == true ? 1 : 0
      };
      cont.strJSON = JSON.stringify(this.editing_phone);
      this.$API("phones", "editPhones", { phone: cont.strJSON, edit_mode: "edit" }, function (data) {
        cont.deleting_phone = null;
        cont.strJSON = "";
        cont.getPhones();
      }, function (errorText) {
        console.log(errorText);
      });
      this.hideModal();
    },
    deletePhone: function deletePhone() {
      var item = this.editing_phone;
      this.editing_phone = null;
      var cont = this;
      cont.deleting_phone = {
        name: item.name,
        phone: item.phone,
        position: item.info.position,
        email: item.info.email,
        status: item.status == true ? 1 : 0
      };
      cont.strJSON = JSON.stringify(this.deleting_phone);
      this.$API("phones", "editPhones", { phone: cont.strJSON, edit_mode: "remove" }, function (data) {
        cont.deleting_phone = null;
        cont.strJSON = "";
        cont.getPhones();
      }, function (errorText) {
        console.log(errorText);
      });
      this.hideDeleteModal();
    }
  },

  watch: {
    locale: function locale() {
      this.getPhones();
    }
  },
  template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */]
};


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "<div>\n<div class=\"phone-list-table\">\n        <b-table\n        :items=\"phones\"\n        :fields=\"fields\"\n        striped\n        dark\n        hover\n        borderless>\n\n        <template v-slot:cell(action)=\"data\">\n        <b-button class=\"icons\" v-on:click=\"showModal(data.item)\"><img src=\"css/edit.svg\"></b-button>\n        </template>\n\n        <template v-slot:cell(delete)=\"data\">\n        <b-button v-on:click=\"showDeleteModal(data.item)\" class=\"icons\"><img src=\"css/delete.svg\"></b-button>\n        </template>\n        </b-table>\n    </div>\n    <div class=\"buttons\">\n    <b-button v-on:click=\"showCreateModal()\">{{$t('phoneList.addEmployee')}}</b-button>\n    \n    <b-modal ref=\"EditModal\" hide-footer\n    header-bg-variant=\"dark\"\n    header-text-variant=\"light\"\n    :title=\"$t('phoneList.editDetails')\">\n      <b-form-group label-for=\"name-input\">\n      <b-col v-for=\"field in options\">\n      <label>{{field.namelabel}}</label>\n        <b-form-input\n        v-model=\"field.info\">\n        </b-form-input>\n        </b-col>\n\n        <b-col>\n        <b-form-checkbox\n         v-model=\"default_phone\"\n         value=\"true\"> \n         {{$t('phoneList.defaultContact')}}\n         </b-form-checkbox>\n        </b-col>\n      </b-form-group>\n      <b-button class=\"mt-4\" block variant=\"success\" @click=\"editPhone(options)\">{{$t('phoneList.edit')}}</b-button>\n      <b-button class=\"mt-2\" block variant=\"dark\" @click=\"hideModal\">{{$t('phoneList.cancel')}}</b-button>\n  </b-modal>\n\n\n  <b-modal ref=\"CreateModal\" hide-footer\n    header-bg-variant=\"dark\"\n    header-text-variant=\"light\"\n    :title=\"$t('phoneList.addNewEmployee')\">\n    <b-container fluid>\n    <b-row v-for=\"type in types\">\n     <b-col sm=\"12\">\n     <label for=\"input-live\">{{type.namelabel}}</label>\n     <b-form-input\n     v-model=\"type.info\" trim>\n     </b-form-input>\n     </b-col>\n     </b-row>\n\n     <b-row>\n     <b-col sm=\"12\">\n     <b-form-checkbox\n     v-model=\"default_phone\"\n     value=\"true\"> \n     {{$t('phoneList.defaultContact')}}\n     </b-form-checkbox>\n     </b-col>\n     </b-row>\n\n     <b-row>\n     <b-col sm=\"12\">\n     <b-button class=\"mt-4\" block variant=\"success\" v-on:click=\"createPhone\">{{$t('phoneList.add')}}</b-button>\n     </b-col>\n     </b-row>\n</b-container>\n  </b-modal>\n\n  <b-modal\n  ref=\"deleteModal\" hide-footer\n  header-bg-variant=\"dark\"\n  header-text-variant=\"light\"\n  title=\"\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\">\n  \n  <div>\n        <h5>{{message}}</h5>\n  </div>\n    <b-button class=\"mt-3\" block variant=\"success\" @click=\"deletePhone()\">\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u043B\u0435\u043C\u0435\u043D\u0442</b-button>\n    <b-button class=\"mt-3\" block variant=\"dark\" @click=\"hideDeleteModal()\">\u041E\u0442\u043C\u0435\u043D\u0430</b-button>\n</b-modal>\n\n</div>\n</div>";


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OneWireData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__left_menu_component_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__info_window_component_js__ = __webpack_require__(42);




var OneWireData = {
  name: "onewire",
  components: {
    "left-menu": __WEBPACK_IMPORTED_MODULE_1__left_menu_component_js__["a" /* Left_menu */],
    "info-window": __WEBPACK_IMPORTED_MODULE_2__info_window_component_js__["a" /* Info_window */]
  },
  template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */],
  data: function data() {
    return {
      modems: [],

      selectedModem: null,

      selectedModemLogs: {}
    };
  },

  created: function created() {
    // Первый запуск
    this.getModems();
  },
  beforeDestroy: function beforeDestroy() {
    // при выходе - убиваем таймер аякса
    clearInterval(this.intervalID);
  },

  methods: {
    modemClick: function modemClick(modem) {
      this.selectedModem = modem; // info_window увидит это, и отрисует график
    },
    getModems: function getModems() {
      var _this = this;

      //запускаем аякс из плагина
      this.$API("static_data", "modems", {}, function (data) {
        _this.modems = data;
      }, function (errorText) {
        console.log(errorText);
      });
    },
    onSelectedDataLoad: function onSelectedDataLoad(data) {
      this.selectedModemLogs = data;
    }
  }
};



/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "\n<div class=\"page-content\">\n\t<left-menu :modems=\"modems\" @line-click=\"modemClick\" :selectedModemLogs=\"selectedModemLogs\"></left-menu>\n\t\n\t<info-window v-if=\"selectedModem\" :selected=\"selectedModem\" @data-load=\"onSelectedDataLoad\"></info-window>\n</div>";



/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Left_menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(41);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var Left_menu = {
  props: {
    modems: Array,
    selectedModemLogs: Object
  },
  components: {
    "ag-grid-vue": window.agGridVue.AgGridVue
  },
  data: function data() {
    return {
      perPage: globalConstants.linesPerPageLeftMenu,
      selectedModem: null,
      newComment: null,
      fields: [{
        field: "wire",
        headerName: ""
      }, {
        field: "serial",
        headerName: this.$t("modems.sN"),
        sortable: true,
        filter: true,
        flex: 1
      }]
    };
  },
  updated: function updated() {
    this.fields[1].label = this.$t("modems.sN");
  },

  computed: {
    transformedModemRows: function transformedModemRows() {
      return this.modems.map(function (m) {
        return _extends({}, m, {
          wire: m.too_old ? "⏰" : "",
          serial: m.serial.length > 35 ? m.serial.slice(0, 35) + "..." : m.serial.slice(0, 35)
        });
      });
    },
    modemInfoFields: function modemInfoFields() {
      if (this.selectedModem) return [{ label: "IMEI", value: this.selectedModemLogs.IMEI }, { label: "IMSI", value: this.selectedModemLogs.IMSI }, { label: "ICCID", value: this.selectedModemLogs.ICCID }, { label: "NUM", value: this.selectedModemLogs.num }, { label: "UTC", value: this.selectedModemLogs.UTC }, {
        label: this.$t("modems.activity"),
        value: (this.selectedModem.too_old && "⏰") + " " + this.selectedModem.measure_time
      }, { label: this.$t("modems.modem"), value: this.selectedModem.serial }];
    }
  },
  methods: {
    onFirstDataRendered: function onFirstDataRendered() {
      this.gridColumnApi.autoSizeColumn("wire");
    },
    onGridReady: function onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onModemChanged: function onModemChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      this.selectedModem = selectedRows[0];
      this.newComment = selectedRows[0].comment;
      this.$emit("line-click", selectedRows[0].serial.includes("...") ? this.modems.find(function (m) {
        return m.serial.includes(selectedRows[0].serial);
      }) : selectedRows[0].serial);
    },
    updateComment: function updateComment() {
      var _this = this;

      //сохраняем комментарий
      this.$API("static_data", "updateModemComment", {
        serial: this.selectedModem.serial,
        comment: this.newComment
      }, function () {
        _this.selectedModem.comment = _this.newComment; //если запрос прошел, записываем переменную, чтобы пропала кнопка сохранения
      }, function () {});
    }
  },
  template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */]
};



/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "\n<div class=\"left-menu-modems\">\n  <ag-grid-vue\n    class=\"ag-theme-balham-dark ag-theme-rtube left-menu-modems__top\"\n    :columnDefs=\"fields\"\n    :rowData=\"transformedModemRows\"\n    pagination=\"true\"\n    :paginationPageSize=\"perPage\"\n    rowSelection=\"single\"\n    @first-data-rendered=\"onFirstDataRendered\"\n    @grid-ready=\"onGridReady\"\n    @selection-changed=\"onModemChanged\">\n  </ag-grid-vue>\n</div>";



/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Info_window; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(43);


var Info_window = {
  components: {
    "ag-grid-vue": window.agGridVue.AgGridVue
  },
  props: {
    selected: String
  },
  data: function data() {
    return {
      perPage: 60,
      periodDays: 10,
      startDate: this.getRangeDate(10),
      endDate: this.getRangeDate(1),
      periods: 60,
      dataPoints: [],
      dataPointsPressure: [],
      dateRanges: [{
        label: this.$t("modems.year"),
        value: 365
      }, {
        label: this.$t("modems.halfYear"),
        value: 183
      }, {
        label: this.$t("modems.days30"),
        value: 30
      }, {
        label: this.$t("modems.days10"),
        value: 10
      }, {
        label: this.$t("modems.days2"),
        value: 2
      }, {
        label: this.$t("modems.day1"),
        value: 1
      }],
      chartT: Object,
      chartP: Object
    };
  },


  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    }
  },

  updated: function updated() {
    this.dateRanges[0].label = this.$t("modems.year");
    this.dateRanges[1].label = this.$t("modems.halfYear");
    this.dateRanges[2].label = this.$t("modems.days30");
    this.dateRanges[3].label = this.$t("modems.days10");
    this.dateRanges[4].label = this.$t("modems.days2");
    this.dateRanges[5].label = this.$t("modems.day1");
  },


  methods: {
    getRangeDate: function getRangeDate(days) {
      var date = new Date();
      date.setDate(date.getDate() - days + 1);
      return date.toISOString().slice(0, 10);
    },
    changeRange: function changeRange(days) {
      this.periodDays = days;
      this.startDate = this.getRangeDate(days);
      this.endDate = this.getRangeDate(1);
    },
    onDateRangeChange: function onDateRangeChange() {
      this.periodDays = null;
    },
    clearChart: function clearChart() {
      document.getElementById('chartContainerTemp').innerHTML = '';
    },
    clearChartPressure: function clearChartPressure() {
      document.getElementById('chartContainerPressure').innerHTML = '';
    },
    getChartsData: function getChartsData() {
      var _this = this;

      var periodBegin = new Date(this.startDate).getTime() / 1000;
      var periodEnd = new Date(this.endDate).getTime() / 1000 + 60 * 60 * 24;

      this.$API("static_data", "onewire_t", {
        serial: this.selected,
        begin: periodBegin,
        end: periodEnd,
        periods: this.periods
      }, function (data) {
        console.log(data);
        if (!data.length) {
          _this.clearChart();
          return;
        }

        _this.dataPoints = [];
        _this.dataPointsPressure = [];

        _this.fillChart(data, (periodBegin + new Date().getTimezoneOffset() * 60) * 1000, (periodEnd + new Date().getTimezoneOffset() * 60) * 1000, "chartContainerTemp", _this.chartT);
      }, function () {});

      this.$API("static_data", "onewire_p", {
        serial: this.selected,
        begin: periodBegin,
        end: periodEnd,
        periods: this.periods
      }, function (data) {
        console.log(data);
        if (!data.length) {
          _this.clearChartPressure();
          return;
        }
        _this.fillChart(data, (periodBegin + new Date().getTimezoneOffset() * 60) * 1000, (periodEnd + new Date().getTimezoneOffset() * 60) * 1000, "chartContainerPressure", _this.chartP);
      }, function () {});
    },
    fillChart: function fillChart(data, begin, end, containerID, chart) {
      var cont = this;

      data.some(function (el) {
        el.x = new Date(el.x * 1000);
      });
      cont.dataPoints = data;
      var axisYTemperature = {
        title: cont.$t("modems.temperature"),
        prefix: "",
        suffix: " " + cont.$t("modems.temperatureUnit"),
        minimum: 0,
        //					maximum: 1800,
        includeZero: true
      };
      var axisYPressure = {
        title: cont.$t("modems.pressure"),
        prefix: "",
        suffix: "" + globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit,
        minimum: 0,
        //					maximum: 1800,
        includeZero: true
      };
      //let interval = Math.round((end - begin) / 1000 / 60 / 60);
      CanvasJS.addCultureInfo("ru", {
        decimalSeparator: ".",
        digitGroupSeparator: ",",
        shortMonths: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"]
      });
      chart = new CanvasJS.Chart(containerID, {
        theme: "dark2", // "light2", "dark1", "dark2"
        animationEnabled: false, // change to true
        zoomEnabled: true,
        culture: cont.$i18n.locale === "ru" ? "ru" : "en",

        axisX: {
          //				valueFormatString: "DD/MM",
          minimum: begin,
          maximum: end
          //				interval: interval,
          //				intervalType: "hour"
        },
        axisY: containerID === "chartContainerTemp" ? axisYTemperature : axisYPressure,
        //axisY: containerID==="chartContainerTemp" ? axisYTemperature : axisYTemperature,
        toolTip: {
          shared: true
        },
        legend: {
          cursor: "pointer",
          verticalAlign: "bottom",
          horizontalAlign: "center",
          dockInsidePlotArea: false,
          itemclick: cont.toogleDataSeries
        },
        data: [{
          type: "line", //spline
          axisYType: "primary",
          xValueType: "dateTime",
          xValueFormatString: "DD/MM/YYYY HH:mm",
          name: containerID === "chartContainerTemp" ? cont.$t("modems.onewire") : cont.$t("modems.onewireP"),
          showInLegend: true,
          color: "#ffff00",
          markerSize: 4,
          markerType: "circle",
          yValueFormatString: containerID === "chartContainerTemp" ? "#,##0.## " + cont.$t("modems.temperatureUnit") : "#,##0.##  " + globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit,
          connectNullData: false,
          dataPoints: cont.dataPoints
        }]
      });

      chart.render();
    }
  },
  watch: {
    locale: function locale() {
      this.getChartsData();
    },

    selected: {
      handler: function handler() {
        this.getChartsData();
      },

      immediate: true
    },
    startDate: function startDate() {
      this.getChartsData();
    },
    endDate: function endDate() {
      this.getChartsData();
    }
  },
  template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */]
};



/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = "\n<div class=\"right-info-modems\">\n  <div class=\"date-range\">\n    <button class=\"input-dark form-control\" v-for=\"date in dateRanges\" v-bind:class=\"{ range_active: periodDays == date.value }\" @click=\"changeRange(date.value)\">{{date.label}}</button>\n    \n    <input class=\"input-dark form-control\" type=\"date\" v-model=\"startDate\" @change=\"onDateRangeChange\">\n    <input class=\"input-dark form-control\" type=\"date\" v-model=\"endDate\" @change=\"onDateRangeChange\">\n  </div>\n  <div class=\"modem-info-logs\">\n    <div id=\"chartContainerTemp\" class=\"chartContainer\" ></div>\n    <div id=\"chartContainerPressure\" class=\"chartContainer\"></div>\n  </div>\n</div>";



/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Auth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_js__ = __webpack_require__(45);


var Auth = {
	template: __WEBPACK_IMPORTED_MODULE_0__template_js__["a" /* Template */],
	data: function data() {
		return {
			username: '',
			password: ''
		};
	},

	methods: {
		setLocale: function setLocale(locale) {
			console.log('меняю');
			this.$emit("setLocale", locale);
		},
		login: function login() {
			var cont = this;
			//авторизация в плагине
			this.$auth(this.username, this.password, function () {
				//авторизация успешна
				cont.$emit("login-result", true);

				var currentPage = localStorage.getItem('currentPage');
				if (!currentPage) {
					currentPage = "/";
				}
				cont.$router.push(currentPage);

				console.log('authorized');

				//спросить пользователя после логина о приеме уведомлений
				var js = document.createElement('script');
				js.src = "./js/firebase-services.js";
				document.body.appendChild(js);
			}, function () {
				// авторизация провалилась
				cont.$emit("login-result", false);
				console.log('authorization failed');
				cont.password = '';
			});
		}
	}
};



/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Template; });
var Template = " <div>\n   <form class=\"login\" @submit.prevent=\"login\" autocomplete=\"on\">\n   <br>\n     <b-dropdown id=\"auth-lang\" dropleft class=\"\" size=\"sm\" variant=\"link\" no-caret>\n      <template v-slot:button-content>\n        <vf-icon :country=\"$t('general.langType')\"/> {{$t('general.lang')}}\n      </template>\n      <b-dropdown-item href=\"#\" @click=\"setLocale('ru')\"><vf-icon country=\"ru\"/> {{this.$i18n.messages.ru.general.lang}}</b-dropdown-item>\n      <b-dropdown-item href=\"#\" @click=\"setLocale('gb')\"><vf-icon country=\"gb\"/> {{this.$i18n.messages.gb.general.lang}}</b-dropdown-item>\n    </b-dropdown>\n     <h1>{{$t('auth.signIn')}}</h1>\n     <label>{{$t('auth.login')}}</label><br>\n     <input required v-model=\"username\" name=\"username\" type=\"text\" :placeholder=\"$t('auth.login')\" autocomplete=\"username\"/><br><br>\n     <label>{{$t('auth.password')}}</label></br>\n     <input required v-model=\"password\" name=\"password\" type=\"password\" :placeholder=\"$t('auth.password')\" autocomplete=\"password\"/><br>\n     <br>\n     <button type=\"submit\" :disabled=\"!username || !password\">{{$t('auth.signIn')}}</button>\n   </form>\n </div>";



/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainTemplate; });
// Note that these are backticks.

var MainTemplate = "\n    <div>\n    <menu-bar v-if=\"logged\" v-on:setLocale=\"setLocale\"></menu-bar>\n    <div class=\"content\">\n        <router-view v-show=\"logged\"></router-view>\n    </div>\n    <auth v-if=\"!logged\" @login-result=\"loginResult\" v-on:setLocale=\"setLocale\"></auth>\n    </div>\n";



/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i18n; });
// import Vue from 'vue'
// import VueI18n from ''

// Vue.use(VueI18n)

var i18n = new VueI18n({
  locale: "ru",
  fallbackLocale: "gb",
  messages: {
    ru: {
      auth: {
        signIn: "Вход",
        login: "Логин",
        password: "Пароль"
      },
      nav: {
        tubes: "Трубы",
        modems: "Модемы",
        users: "Пользователи",
        addModem: "Добавить модем",
        messages: "Сообщения",
        telList: "Список телефонов",
        signOut: "Выход",
        oneWireData: "Данные OneWire"
      },
      tubes: {
        tube: "Труба",
        modem: "Модем",
        serialNumber: "Серийный номер",
        activity: "Активность",
        isol: "Изоляция",
        battery: "Батарея",
        wire: "Провод",
        phones: "Телефоны",
        coordinates: "Координаты",
        comment: "Комментарий",
        enterComment: "Введите комментарий",
        saveComment: "Сохранить",
        year: "Год",
        halfYear: "Полгода",
        days30: "30 дней",
        days10: "10 дней",
        days2: "2 дня",
        day1: "День",
        isolResistance: "Сопротивление изоляции",
        ohm: "Ом",
        kOhm: "кОм",
        photo: "Фото"
      },
      modems: {
        sN: "С/Н",
        modem: "Модем",
        fullSerial: "Полный серийный",
        tube: "Труба",
        activity: "Активность",
        battery: "Батарея",
        coords: "Координаты",
        comment: "Комментарий",
        enterComment: "Введите комментарий",
        saveComment: "Сохранить",
        aboutDevice: "Об устройстве",
        receivingTime: "Время получения",
        formationTime: "Время формирования",
        allReason: "Вcе типы сообщений",
        messageReason: "Тип сообщения",
        temperature: "Температура",
        temperatureUnit: "°C",
        batteryLevel: "Уровень батареи",
        // IMEI: 'IMEI',
        // ICCID: '',
        // NUM: 'UTC',
        year: "Год",
        halfYear: "Полгода",
        days30: "30 дней",
        days10: "10 дней",
        days2: "2 дня",
        day1: "День",
        onewire: "Onewire Температура",
        onewireP: "Onewire Давление",
        pressure: "Давление"
      },
      users: {
        login: "Логин",
        password: "Пароль",
        email: "E-mail",
        group: "Группа",
        user: "Пользователь",
        admin: "Администратор",
        phone: "Телефон",
        checkbox1: "Извещать о важных событиях",
        checkbox2: "Извещать о всех событиях",
        edit: "Редактировать",
        create: "Создать",
        delete: "Удалить",
        save: "Сохранить",
        cancel: "Отменить",
        enterLogin: "введите логин",
        enterPassword: "введите пароль",
        incorrectEmail: "некорректный e-mail",
        phoneFormat: "формат номера 375XXXXXXXXX",
        unchanged: "не изменен",
        dontMatch: "не совпадает"
      },
      addModem: {
        tube: "Труба",
        modemsSN: "С/Н модема",
        addModemh1: "Добавление нового модема",
        manually: "Ввести вручную",
        fromFile: "Загрузить из файла",
        serialNumber: "Серийный номер модема (номер по порядку)",
        fullSerial: "Полный серийный номер модема (IMEI)",
        tubeName: "Название трубы",
        scanQR: "Сканируйте qr-код или",
        qrLink: "Пройдите по ссылке",
        modemComment: "Комментарий к модему",
        tubeComment: "Комментарий к трубе",
        enterComment: "Введите комметарий",
        modemCoords: "Координаты модема",
        tubeCoords: "Координаты трубы",
        addContacts: "Добавить контакты",
        chooseAll: "Выбрать все",
        resetAll: "Сбросить все",
        addAndContinue: "Добавить и продолжить",
        addModemButton: "Добавить модем",
        ok: "Хорошо",
        addStatus: "Статус добавления элемента",
        message1: "Обязательно для заполнения!",
        message2: "Неверный формат координат",
        message3: "Такой элемент уже есть в списке!",
        message4: "Элемент был успешно добавлен!",
        editTubeData: "Отредактируйте данные о трубе",
        editContacts: "Изменить контакты",
        serNumber: "Серийный номер",
        fullSerNumber: "Полный серийный номер"
      },
      messages: {
        sN: "С/Н",
        time: "Время",
        modemSN: "С/Н модема",
        tube: "Труба",
        message: "Сообщение",
        filterBy: "Фильтровать по",
        break: "Обрыв",
        lowBattery: "Разряжена батарея",
        sodden: "Намокание",
        noSignal: "Нет сигнала",
        resetButton: "Сбросить",
        break2: " Обрыв провода \n",
        sodden2: " Намокание трубы \n",
        lowBattery2: " Батарея разряжена \n",
        noSignal2: " Долго нет сигнала \n"
      },
      phoneList: {
        employee: "Сотрудник",
        phone: "Телефон",
        addEmployee: "Добавить сотрудника",
        editDetails: "Отредактируйте данные сотрудника:",
        defaultContact: "Контакт по умолчанию",
        edit: "Изменить",
        cancel: "Отмена",
        add: "Добавить",
        addNewEmployee: "Добавить нового сотрудника:",
        employeeName: "ФИО сотрудника",
        phoneNumber: "Номер телефона",
        position: "Должность",
        email: "Email"
      },
      general: {
        search: "Поиск",
        lang: "Русский",
        langType: "ru",
        edit: "Изменить",
        cancel: "Отмена"
      }
    },
    gb: {
      auth: {
        signIn: "Sign in",
        login: "Login",
        password: "Password"
      },
      nav: {
        tubes: "Tubes",
        modems: "Modems",
        users: "Users",
        addModem: "Add modem",
        messages: "Messages",
        telList: "Phone list",
        signOut: "Sign out",
        oneWireData: "OneWire Data"
      },
      tubes: {
        tube: "Tube",
        modem: "Modem",
        serialNumber: "Serial number",
        activity: "Activity",
        isol: "Insulation",
        battery: "Battery",
        wire: "Wire",
        phones: "Phones",
        coordinates: "Coordinates",
        comment: "Comment",
        enterComment: "Enter comment",
        saveComment: "Save",
        year: "Year",
        halfYear: "Half a year",
        days30: "30 days",
        days10: "10 days",
        days2: "2 days",
        day1: "1 day",
        isolResistance: "Insulation resistance",
        ohm: "Ohm",
        kOhm: "kOhm",
        photo: "Photo"
      },
      modems: {
        sN: "S/N",
        modem: "Modem",
        fullSerial: "Full serial",
        tube: "Tube",
        activity: "Activity",
        battery: "Battery",
        coords: "Coordinates",
        comment: "Comment",
        enterComment: "Enter comment",
        saveComment: "Save",
        aboutDevice: "About device",
        receivingTime: "Receiving time",
        formationTime: "Formation time",
        allReason: "All message's reasons",
        messageReason: "Message's reason",
        temperature: "Temperature",
        temperatureUnit: "°C",
        batteryLevel: "Battery level",
        // IMEI: 'IMEI',
        // ICCID: '',
        // NUM: 'UTC',
        year: "Year",
        halfYear: "Half a year",
        days30: "30 days",
        days10: "10 days",
        days2: "2 days",
        day1: "1 day",
        onewire: "Onewire Temperature",
        onewireP: "Onewire Pressure",
        pressure: "Pressure"
      },
      users: {
        login: "Login",
        password: "Password",
        email: "E-mail",
        group: "Group",
        user: "User",
        admin: "Admin",
        phone: "Phone",
        checkbox1: "Notify about important events",
        checkbox2: "Notify about all events",
        edit: "Edit",
        create: "Create",
        delete: "Delete",
        save: "Save",
        cancel: "Cancel",
        enterLogin: "enter login",
        enterPassword: "enter password",
        incorrectEmail: "incorrect e-mail",
        phoneFormat: "number format 375XXXXXXXXX",
        unchanged: "unchanged",
        dontMatch: "doesn't match"
      },
      addModem: {
        tube: "Tube",
        modemsSN: "Modem S/N",
        addModemh1: "Adding a new modem ",
        manually: "Enter manually",
        fromFile: "Load from file",
        serialNumber: "Modem serial number",
        fullSerial: "Modem full serial number",
        tubeName: "Tube name",
        scanQR: "Scan QR code or",
        qrLink: "Follow the link",
        modemComment: "Modem comment",
        tubeComment: "Tube comment",
        enterComment: "Enter comment",
        modemCoords: "Modem coordinates",
        tubeCoords: "Tube coordinates",
        addContacts: "Add contacts",
        chooseAll: "Choose all",
        resetAll: "Reset all",
        addAndContinue: "Add and continue",
        addModemButton: "Add modem",
        ok: "Ok",
        addStatus: "Item adding status",
        message1: "Required to fill out!",
        message2: "Invalid coordinate format",
        message3: "This item is already in the list!",
        message4: "The item was added successfully!",
        editTubeData: "Edit tube data",
        editContacts: "Edit contacts",
        serNumber: "Serial number",
        fullSerNumber: "Full serial number"
      },
      messages: {
        sN: "S/N",
        time: "Time",
        modemSN: "Modem S/N",
        tube: "Tube",
        message: "Message",
        filterBy: "Filter by",
        break: "Break",
        lowBattery: "Low battery",
        sodden: "Sodden",
        noSignal: "No signal",
        resetButton: "Reset",
        break2: " Broken wire \n",
        sodden2: " Sodden tube \n",
        lowBattery2: " Battery discharged \n",
        noSignal2: " Long no signal \n"
      },
      phoneList: {
        employee: "Employee",
        phone: "Phone",
        addEmployee: "Add employee",
        editDetails: "Edit employee details:",
        defaultContact: "Default contact",
        edit: "Edit",
        cancel: "Cancel",
        add: "Add",
        addNewEmployee: "Add new employee:",
        employeeName: "Name of employee",
        phoneNumber: "Phone number",
        position: "Position",
        email: "Email"
      },
      general: {
        search: "Search",
        lang: "English",
        langType: "gb",
        edit: "Edit",
        cancel: "Cancel"
      }
    }
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MainPlugin = {
  install: function install(Vue, options) {
    Vue.prototype.$logged = function () {
      var now = Math.floor(Date.now() / 1000);
      var currentToken = localStorage.getItem('token');
      var currentTokenExpiration = parseInt(localStorage.getItem('tokenExpiration'));
      if (!currentToken || !currentTokenExpiration) {
        currentToken = '';
        currentTokenExpiration = 0;
      }
      if (currentTokenExpiration + globalConstants.tokenExpireTime < now) {
        if (this.$router.history.current.path != '/login') {
          localStorage.setItem('currentPage', this.$router.history.current.path);
        };
        console.log('token expired', currentTokenExpiration, now);
        this.$root.logged = false;
        this.$clearLogin();
        return false;
      }
      this.$root.logged = true;
      return true;
    };

    Vue.prototype.$clearLogin = function () {
      console.log('auth cleared');
      this.$root.logged = false;
      localStorage.setItem('token', '');
      localStorage.setItem('tokenExpiration', 0);
      localStorage.setItem('group', '');
      if (!this.$router.history.current.path != '/login') // порехедим на страницу входа, если еще не там
        this.$router.push('/login');
    };
    Vue.prototype.$saveLogin = function (token, tokenExpiration, group) {
      console.log('auth filled');
      localStorage.setItem('token', token);
      localStorage.setItem('tokenExpiration', tokenExpiration);
      localStorage.setItem('group', group);
    };

    Vue.prototype.$API = function (controller, func, parameters, callback, errorFunction) {
      //выход, если не авторизованы
      if (!this.$logged()) {
        this.$clearLogin();
        errorFunction('auth_failed');
        return false;
      }
      var cont = this;

      var url = globalConstants.backendUrl + '?controller=' + controller + '&function=' + func;

      var data = new FormData();
      // токен для всех запросов
      data.append('token', localStorage.getItem('token'));
      //данные запроса
      for (var prop in parameters) {
        data.append(prop, parameters[prop]);
      }
      axios.post(url, data).then(function (response) {
        // handle success
        // console.log(response);
        if (typeof response.data.result !== 'undefined' && response.data.result === 'ok') {
          callback(response.data.data); //запускаем коллбкэ, передавая данные
        } else {
          if (typeof response.data.result !== 'undefined' && typeof response.data.data.text !== 'undefined' && (response.data.data.text == 'bad_token' || response.data.data.text == 'no_user')) cont.$clearLogin();
          throw "no_success_api_message";
        }
      }).catch(function (error) {
        // handle error
        console.log(error);
        errorFunction(error);
      }).finally(function () {
        // always executed
      });
    };
    Vue.prototype.$auth = function (username, password, authorized, failed) {
      var cont = this;

      var data = new FormData();

      data.append('user', username);
      data.append('password', password);
      axios.post(globalConstants.backendUrl + '?controller=users&function=login', data).then(function (response) {
        // handle success
        console.log(response);

        if (typeof response.data.result !== 'undefined' && response.data.result === 'ok') {
          var now = Math.floor(Date.now() / 1000);
          console.log('good', response.data.data.group, now + globalConstants.tokenExpireTime);

          cont.$saveLogin(response.data.token, now, response.data.data.group);

          authorized();
        } else {
          if (typeof response.data.result !== 'undefined' && typeof response.data.data.text !== 'undefined' && (response.data.data.text == 'bad_token' || response.data.data.text == 'no_user')) cont.$clearLogin();
          throw "no_success_auth_message";
        }
      }).catch(function (error) {
        // handle error
        console.log(error);
        cont.$clearLogin();
        failed(error);
      }).finally(function () {
        // always executed
      });
    };
    Vue.prototype.$getColorTemp = function (value) {

      //value from 0 to 1
      //value = 100 - value;
      var r = (value < 50 ? 200 : Math.floor(200 - (value * 2 - 100) * 200 / 100)).toString(16);
      var g = (value > 50 ? 200 : Math.floor(value * 2 * 200 / 100)).toString(16);
      if (r.length == 1) r = "0" + r;
      if (g.length == 1) g = "0" + g;
      var color = "#" + r + g + "00";
      //console.log(value, color);
      return color;
    };
    // We call Vue.mixin() here to inject functionality into all components.
    Vue.mixin({
      data: function data() {
        return {};
      },

      mounted: function mounted() {
        if (this.$router.history.current.path != '/login') {
          localStorage.setItem('currentPage', this.$router.history.current.path);
        };
        console.log('плагин mounted');
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (MainPlugin);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js